import React, { useEffect, useRef, useState } from 'react';
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'
import '../../Users/All/AllUser.css'
import useAuth from '../../../useAuth'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import useDebounce from '../../../utils/useDebounce';
import { MEDIA_SERVER_URL } from '../../../constants/constants';

// Loader component
function Loader() {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    );
}

function Adds() {
    const allVideoApis = require('../../../apis/all_user_video');
    const allfeedApis = require("../../../../src/apis/feed");
    const allUserApis = require("../../../apis/users");

    const { user } = useAuth()
    const role = user ? user.role : null;
    // console.log(user?.permissions?.Videos, "video section user?.permissions?.Users")
    const hasvideoDelete = user?.permissions?.Videos?.Delete?.selected || user?.role === 'superadmin';
    const hasBlockVideo = user?.permissions?.Videos?.['Block Video']?.selected || user?.role === 'superadmin';
    const hasRankVideo = user?.permissions?.Videos?.['Rank Video']?.selected || user?.role === 'superadmin';
    const hasProfileRankVideo = user?.permissions?.Videos?.['Profile Rank Video']?.selected || user?.role === 'superadmin';
    const hasViewComment = user?.permissions?.Videos?.['View Comment']?.selected || user?.role === 'superadmin';
    const hasmutevideocommet = user?.permissions?.Videos?.['Mute Comment']?.selected || user?.role === 'superadmin';
    const hasSubFeatureEditvideocommet = user?.permissions?.Videos?.['View Comment']?.subfeatures?.['Edit Video Comment'] || user?.role === 'superadmin';
    const hasSubFeatureDeletevideocommet = user?.permissions?.Videos?.['View Comment']?.subfeatures?.['Delete Video Comment'] || user?.role === 'superadmin';
    const hasEditSection = user?.permissions?.Videos?.['Edit section']?.selected || user?.role === 'superadmin';
    const hasMuteAudio = user?.permissions?.Videos?.['Mute Audio']?.selected || user?.role === 'superadmin';
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [adds, setAdds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [videosPerPage] = useState(10);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [thumbnailClicked, setThumbnailClicked] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAddId, setSelectedAddId] = useState(null);
    const [pageRange, setPageRange] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
    const [expandedVideos, setExpandedVideos] = useState({});
    //testing
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('')
    const [pageWindow, setPageWindow] = useState({ start: 1, end: 20 });
    //openRankedModal
    const [isrankedModalOpen, setrankedIsModalOpen] = useState(false);
    const [Selectedrankedvideoid, setSelectedrankedvideoid] = useState(null);
    const [selectedAdForEdit, setSelectedAdForEdit] = useState(null);

    const [inputPageNumber, setInputPageNumber] = useState('');
    const [inputFocus, setInputFocus] = useState(false);
    const [buttonFocus, setButtonFocus] = useState(false);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const [selectedVideoUrl, setSelectedVideoUrl] = useState('');
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const [allAdImages, setAllAdImages] = useState([]);

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    const getAllAdds = async (page, searchTerm = '', startDate = null, endDate = null) => {

        try {
            setLoading(true);
            let filter = { page, searchTerm };

            if (startDate) {
                filter.startDate = startDate.toISOString();
            }

            if (endDate) {
                filter.endDate = endDate.toISOString();
            }

            const response = await allVideoApis.getAllAdds(filter);
            setAdds(response.ads);

            setTotalPages(response.pagination.totalPages);

        } catch (error) {
            console.error("Error fetching AllVideos:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllAdds(currentPage, debouncedSearchTerm, startDate, endDate);
    }, [currentPage, debouncedSearchTerm, startDate, endDate, isrankedModalOpen]);

    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
    };

    const openVideoModal = (videoUrl) => {
        setSelectedVideoUrl(videoUrl);
        setIsVideoModalOpen(true);
    };

    const closeVideoModal = () => {
        setIsVideoModalOpen(false);
        setSelectedVideoUrl('');
    };
    const openImageModal = (imageUrl, ad = null) => {
        setSelectedImageUrl(imageUrl);

        // If an ad object is provided, collect all its images
        if (ad) {
            const images = [];
            if (ad.image1_url) images.push(ad.image1_url);
            if (ad.image2_url) images.push(ad.image2_url);
            if (ad.image3_url) images.push(ad.image3_url);
            if (ad.image4_url) images.push(ad.image4_url);
            if (ad.image5_url) images.push(ad.image5_url);
            if (ad.image6_url) images.push(ad.image6_url);
            if (ad.image7_url) images.push(ad.image7_url);

            setAllAdImages(images);
        } else {
            setAllAdImages([imageUrl]);
        }

        setIsImageModalOpen(true);
    };

    const closeImageModal = () => {
        setIsImageModalOpen(false);
        setSelectedImageUrl('');
        setAllAdImages([]);
    };

    const nextImage = () => {
        if (allAdImages.length > 1) {
            const currentIndex = allAdImages.indexOf(selectedImageUrl);
            const nextIndex = (currentIndex + 1) % allAdImages.length;
            setSelectedImageUrl(allAdImages[nextIndex]);
        }
    };

    const prevImage = () => {
        if (allAdImages.length > 1) {
            const currentIndex = allAdImages.indexOf(selectedImageUrl);
            const prevIndex = (currentIndex - 1 + allAdImages.length) % allAdImages.length;
            setSelectedImageUrl(allAdImages[prevIndex]);
        }
    };

    // Dynamically update the initial page range based on totalPages
    useEffect(() => {
        const initialRange = [];
        const rangeSize = 10;
        const totalVisiblePages = Math.min(rangeSize, totalPages);

        for (let i = 1; i <= totalVisiblePages; i++) {
            initialRange.push(i);
        }
        setPageRange(initialRange);
    }, [totalPages]);

    const updatePageRange = (startPage) => {
        const rangeSize = 10; // Number of pages visible at a time
        const newRange = [];

        for (
            let i = startPage;
            i < startPage + rangeSize && i <= totalPages;
            i++
        ) {
            newRange.push(i);
        }

        setPageRange(newRange);
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);

        // If the clicked page is the last in the current range, load the next range
        if (page === pageRange[pageRange.length - 1] && page < totalPages) {
            updatePageRange(page);
        }

        // If the clicked page is the first in the current range and not the first page
        if (page === pageRange[0] && page > 1) {
            updatePageRange(page - 9);
        }
    };

    const handleFirst = () => {
        setCurrentPage(1);
        updatePageRange(1);
    };

    const handleLast = () => {
        setCurrentPage(totalPages);
        const lastRangeStart = Math.max(
            1,
            Math.floor((totalPages - 1) / 10) * 10 + 1
        );
        updatePageRange(lastRangeStart);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            // Check if we are at the start of the current visible range
            if (currentPage === pageRange[0]) {
                // If we are at the first page of the range, move to the previous set of pages
                const previousRangeStart = Math.max(pageRange[0] - 10, 1); // Ensure start page is >= 1
                updatePageRange(previousRangeStart);
            } else {
                setCurrentPage(currentPage - 1);
            }
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            // If we are at the end of the current visible range, load the next range
            if (currentPage === pageRange[pageRange.length - 1] && currentPage < totalPages) {
                updatePageRange(pageRange[pageRange.length - 1]);
            } else {
                setCurrentPage(currentPage + 1);
            }
        }
    };

    const handleGoToPage = () => {
        const page = parseInt(inputPageNumber, 10);

        // Ensure the page number is a valid number and within the valid range
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);

            // Calculate the range for the current page
            const startPage = Math.floor((page - 1) / 10) * 10 + 1;
            updatePageRange(startPage);
        } else {
            alert('Please enter a valid page number!');
        }
    };

    //testing end
    // *****************************block Video*********************
    const [IsBlockVideo, setIsBlockVideo] = useState(false)
    const [BlockVideoId, setBlockVideoId] = useState(null)
    const openVideoBlockModal = (videoId) => {
        setIsBlockVideo(true)
        setBlockVideoId(videoId)
    };
    const closeVideoBlockModal = () => {
        setIsBlockVideo(false)
        setBlockVideoId(null)
    };
    const blockvideohandler = async (formData) => {
        // const userConfirmed = window.confirm("Are you sure you want to block this video?");

        // // If the user did not confirm, exit the function
        // if (!userConfirmed) {
        //   return;
        // }
        try {
            const response = await allVideoApis.blockVideo(BlockVideoId, formData);
            if (response.success) {
                alert(response.message);
                setIsBlockVideo(false)
                setBlockVideoId(null)
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching blockVideos:", error);
            setLoading(false); // Handle loading state on error as well
        }
    }
    // *********************************************mute Audio**************************
    const [IsBlockMuteVideoAudio, setIsBlockMuteVideoAudio] = useState(false)
    const [BlockMuteAudioVideoId, setBlockMuteAudioVideoId] = useState(null)
    const openVideoAudioMuteModal = (videoId) => {
        setIsBlockMuteVideoAudio(true)
        setBlockMuteAudioVideoId(videoId)
    };
    const closeVideoAudioMuteModal = () => {
        setIsBlockMuteVideoAudio(false)
        setBlockMuteAudioVideoId(null)
    };
    const HandleMuteVideoAudio = async (formData) => {
        // const userConfirmed = window.confirm("Are you sure you want to block this video?");

        // // If the user did not confirm, exit the function
        // if (!userConfirmed) {
        //   return;
        // }
        try {
            const response = await allVideoApis.handleMuteVideoAudio(BlockMuteAudioVideoId, formData);
            if (response.success) {
                alert(response.message);
                setIsBlockMuteVideoAudio(false)
                setBlockMuteAudioVideoId(null)
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching blockVideos:", error);
            setLoading(false); // Handle loading state on error as well
        }
    }
    // *********************************************mute Audio**************************


    //   // Calculate the index range for the videos to display on the current page
    const indexOfLastVideo = currentPage * videosPerPage;
    const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
    // const currentVideos = videos.slice(indexOfFirstVideo, indexOfLastVideo);
    // console.log(currentVideos,'currentVideos')
    // Function to change the current page
    // const paginate = (pageNumber) => {
    //   setCurrentPage(pageNumber);
    //   setSelectedVideo(null); // Clear selected video when changing pages
    // };

    // Function to show the video when a user clicks on the thumbnail
    const showVideo = (video) => {
        setSelectedVideo(video);
        setThumbnailClicked(true);
    };

    // Function to go back to the video list
    const closeVideo = () => {
        setSelectedVideo(null);
        setThumbnailClicked(false);
    };

    const handleDeleteAd = async (id) => {
        console.log("are you sure you want to delete this add", id);
        try {
            setLoading(true);
            const response = await allVideoApis.deleteAdd(id);
            console.log(response, "response")

            if (response.success === true) {
                alert('Successfully deleted the add');

                getAllAdds();
            }
        } catch (error) {
            console.error("Error while deleteing the add:", error);
            alert("Error while deleteing the add:", error);
        } finally {
            setLoading(false);
            closeModal();
        }
    }

    const openModal = (id) => {
        setSelectedAddId(id);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedAddId(null);
    };

    const handleRankedVideo = async (videoid, totalSeconds, ranked, links, images, addlink, linktext) => {
        setLoading(true)
        // Create a FormData object
        const formData = new FormData();
        formData.append('videoid', videoid);
        formData.append('addlink', addlink);
        formData.append('linktext', linktext);


        formData.append('totalSeconds', totalSeconds);
        formData.append('rank', ranked);

        // Append each link and corresponding image to the FormData object
        links.forEach((link, index) => {
            formData.append(`link`, link);
            // console.log(`link`, link)

        });
        images.forEach((image, index) => {
            formData.append(`image`, image);
            // console.log(`rankimage`, image)

        });
        try {
            // const data = {
            //   videoid: videoid,
            //   totalSeconds: totalSeconds,
            //   ranked: ranked,
            //   link:link
            // }
            const response = await allVideoApis.addrankedvideo(formData);
            console.log(response)
            // After data is fetched, set loading to false
            setLoading(false);
            if (response.success === true) {
                alert('Successfully add ranked');

            } else {
                alert(response.message)
            }
            setrankedIsModalOpen(false);

        } catch (error) {
            console.error("Error fetching AllVideos:", error);
            setLoading(false); // Handle loading state on error as well
        }
    };

    const openRankedModal = (ad = null) => {
        console.log("Editing ad:", ad)
        setSelectedAdForEdit(ad);
        setrankedIsModalOpen(true);
    };

    const closeblockModal = () => {
        setrankedIsModalOpen(false);
        setisprofilerankedModalOpen(false)
        setSelectedrankedvideoid(null);
        setSelectedprofilerankedvideoid(null)
    };


    //profile rank
    const handleprofileRankedVideo = async (videoid, totalSeconds, ranked, links, images, addlink, linktext, username) => {
        setLoading(true)
        // Create a FormData object
        const formData = new FormData();
        formData.append('videoid', videoid);
        formData.append('addlink', addlink);
        formData.append('linktext', linktext);
        formData.append('username', username);

        formData.append('totalSeconds', totalSeconds);
        formData.append('rank', ranked);

        // Append each link and corresponding image to the FormData object
        links.forEach((link, index) => {
            formData.append(`link`, link);
            // console.log(`link`, link)

        });
        images.forEach((image, index) => {
            formData.append(`image`, image);
            // console.log(`rankimage`, image)

        });
        try {

            const response = await allVideoApis.addprofilerankedvideo(formData);
            console.log(response)
            // After data is fetched, set loading to false
            setLoading(false);
            if (response.success === true) {
                alert('Successfully add ranked');

            } else {
                alert(response.message)
            }
            setisprofilerankedModalOpen(false);

        } catch (error) {
            console.error("Error fetching AllVideos:", error);
            setLoading(false); // Handle loading state on error as well
        }

    }
    const [isprofilerankedModalOpen, setisprofilerankedModalOpen] = useState(false);
    const [Selectedprofilerankedvideoid, setSelectedprofilerankedvideoid] = useState(null);
    const openprofileRankedModal = (videoid) => {
        setSelectedprofilerankedvideoid(videoid);
        setisprofilerankedModalOpen(true);
    };
    const handleNoAccess = () => {
        alert('You are not able to access this feature.');
    };

    const [ShowAllCommentModel, setShowAllCommentModel] = useState(false)
    const [SelectCommentVideoid, setSelectCommentVideoid] = useState(null)
    const [CommentData, setCommentData] = useState([])
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isEditReplyCommentModalOpen, setisEditReplyCommentModalOpen] = useState(false)
    const OpenShowCommentModel = (videoid) => {
        setSelectCommentVideoid(videoid)
        GetAllCommentByVideoId(videoid)
        setShowAllCommentModel(true)
    }
    const closeViewCommentModal = () => {
        setShowAllCommentModel(false)
        setIsEditModalOpen(false)
        setisEditReplyCommentModalOpen(false)
    };
    const GetAllCommentByVideoId = async (videoid) => {
        setLoading(true)

        try {
            const response = await allVideoApis.GetAllCommentByVideoId(videoid);
            console.log(response.video, 'response.video')
            setCommentData(response.video)
            // After data is fetched, set loading to false
            setLoading(false)

        } catch (e) {
            console.log(e)
        }
    }


    const HandleComment = async (payload) => {
        try {
            const response = await allVideoApis.EditComment(payload);
            if (response.success) {

                alert(response.message)
                setIsEditModalOpen(false)

                GetAllCommentByVideoId(SelectCommentVideoid)

            }
            // After data is fetched, set loading to false
            setLoading(false)

        } catch (e) {
            console.log(e)
        }
    }

    const HandleCommentDelet = async (id) => {
        try {
            const response = await allVideoApis.DeleteComment(id);
            if (response.success) {

                alert(response.message)

                GetAllCommentByVideoId(SelectCommentVideoid)

            }
            setLoading(false)

        } catch (e) {
            console.log(e)
        }
    }

    const HandleReplyComment = async (payload) => {
        try {
            const response = await allVideoApis.EditReplyComment(payload);
            if (response.success) {

                alert(response.message)
                setisEditReplyCommentModalOpen(false)

                GetAllCommentByVideoId(SelectCommentVideoid)

            }
            // After data is fetched, set loading to false
            setLoading(false)

        } catch (e) {
            console.log(e)
        }
    }

    const HandleCommentReplyDelete = async (id) => {
        try {
            const response = await allVideoApis.DeleteReplyComment(id);
            if (response.success) {

                alert(response.message)

                GetAllCommentByVideoId(SelectCommentVideoid)

            }
            setLoading(false)

        } catch (e) {
            console.log(e)
        }
    }
    const blockuser = {

        float: 'right',
        margin: '4px',
        borderRadius: '20px'
    };

    // ***************************mute video comment*****************
    const [isBlockModelOpen, SetisBlockModelOpen] = useState(false)
    const [searchresult, setsearcresult] = useState([])

    const FeatchUsers = async (query) => {
        try {
            const response = await allfeedApis.FetchUserInfo(query);
            console.log(response, 'response')
            setsearcresult(response?.users)
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const handleCommentMuteUser = async (formData) => {
        // console.log(userId, totalSeconds, reason, 'userId,totalSeconds,reason')
        const userId = formData.get("userId");

        // const mutefor='feed'

        try {
            // const response = await allUserApis.MuteUserComment(userId, mutefor,totalSeconds, reason);
            const response = await allUserApis.MuteUserComment(userId, formData);

            if (response.success) {
                alert('Comment has been muted successfully')
                SetisBlockModelOpen(false)
                setsearcresult(null)
            } else {
                alert(response.message)
                SetisBlockModelOpen(false)

                setsearcresult(null)

            }
            // console.log('User has been muted successfully:', response);
            // Perform any necessary action after a successful update on the server
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    }

    const OpenBlockModel = () => {
        SetisBlockModelOpen(true)
    }

    const CloseModel = () => {
        SetisBlockModelOpen(false)
        setsearcresult(null)


    }
    // ***************************mute video comment*****************

    // ***************************Edit Section*****************
    const [isEditSectionModelOpen, SetisEditSectionModelOpen] = useState(false)
    const [SelectedvideoId, setSelectedvideoId] = useState([])
    const OpenEditSection = (video) => {
        SetisEditSectionModelOpen(true)
        setSelectedvideoId(video)
    }
    const CloseEditVideoInfoModel = () => {
        SetisEditSectionModelOpen(false)
        setSelectedvideoId(null)


    }
    const handleEditTitleAndDiscription = async (data) => {

        // const mutefor='feed'
        try {
            // const response = await allUserApis.MuteUserComment(userId, mutefor,totalSeconds, reason);
            const response = await allVideoApis.UpdateEDitVideoInfo(data);

            if (response.success) {
                alert(`${data.type} is successfully Updated.`)

                SetisEditSectionModelOpen(false)
                setSelectedvideoId(null)
                getAllAdds();
            }
            else {
                alert(response.message)
            }
            // console.log('User has been muted successfully:', response);
            // Perform any necessary action after a successful update on the server
        } catch (error) {
            console.error('Error updating user status:', error);
        }
    }

    // ***************************Edit Section*****************

    const cleanHandler = () => {
        setStartDate(null);
        setEndDate(null);
        setSearchTerm('');

        setTimeout(() => {
            getAllAdds(currentPage, '', null, null);
        }, 0); // Timeout ensures state updates are applied first
    }


    const toggleDescription = (videoId) => {
        setExpandedVideos((prevState) => ({
            ...prevState,
            [videoId]: !prevState[videoId],
        }));
    };
    return (
        <IncludeSideBar>
            <div>
                <h2>All Adds</h2>


                <input
                    type="text"
                    placeholder="Search by add ID or Title"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                />

                <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginRight: '10px' }}>Filter  </label>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="Start Date"
                            maxDate={new Date()}
                            dateFormat="dd:MM:yyyy"

                            style={{
                                padding: '5px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                fontSize: '14px',
                            }}
                        />
                        <span style={{ margin: '0 10px' }}>to</span>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="End Date"
                            minDate={startDate}
                            maxDate={new Date()}
                            dateFormat="dd:MM:yyyy"

                            style={{
                                padding: '5px',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                fontSize: '14px',
                            }}
                        />
                        <button
                            style={{
                                padding: '6px 12px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                            onClick={cleanHandler}>
                            Clean
                        </button>
                    </div>

                    <button onClick={() => {
                        if (hasRankVideo) {
                            openRankedModal()
                        } else {
                            handleNoAccess()
                        }
                    }}
                        style={{
                            backgroundColor:
                                !hasRankVideo
                                    ? '#C5C6C7'
                                    : '',
                            cursor: !hasRankVideo ? 'not-allowed' : 'pointer',
                            borderRadius: '20px',
                            marginLeft: '10px'
                        }}>
                        Create Add
                    </button>
                </div>

                {loading ? (
                    <Loader />
                ) : selectedVideo ? (
                    <div>
                        <h3 style={{ fontSize: '1.5em', marginBottom: '10px' }}>Video Details</h3>
                        <img
                            src={`${MEDIA_SERVER_URL}/${selectedVideo?.user?.profile_pic}`}
                            style={{
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                marginBottom: '10px',
                                marginLeft: '48%',
                            }}
                        />
                        <p style={{ marginBottom: '10px' }}>
                            <strong>User ID:</strong> {selectedVideo?.user.id}
                        </p>
                        <p style={{ marginBottom: '10px' }}>
                            <strong>Comments:</strong> {selectedVideo?.comments.length}
                        </p>
                        <p style={{ marginBottom: '10px' }}>
                            <strong>Views:</strong> {selectedVideo?.viewCount}
                        </p>
                        <p style={{ marginBottom: '10px' }}>
                            <strong>User Name:</strong> {selectedVideo?.user?.nickname}
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                            <video controls width="400">
                                <source
                                    src={`${MEDIA_SERVER_URL}/${selectedVideo?.video}`}
                                    type="video/mp4"
                                />
                            </video>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                            <button
                                onClick={closeVideo}
                                style={{
                                    backgroundColor: 'red',
                                    color: 'white',
                                    border: 'none',
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                }}
                            >
                                Close Video
                            </button>
                        </div>
                    </div>
                ) : (

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Image</th>
                                <th>Video</th>
                                <th>Admin Name</th>
                                <th>Title</th>
                                <th>Content</th>
                                <th>Type</th>
                                <th>Created Date</th>
                                <th>End Time</th>
                                <th>Status</th>
                                <th>Rank</th>
                                <th>Duration</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {adds.map((ad) => {
                                const isExpanded = expandedVideos[ad?.id];
                                const shouldTruncate = ad?.content?.length > 50;
                                const displayedContent =
                                    isExpanded || !shouldTruncate
                                        ? ad?.content
                                        : ad?.content.slice(0, 50) + "...";

                                // Collect all images from the ad
                                const adImages = [];
                                if (ad.image1_url) adImages.push(ad.image1_url);
                                if (ad.image2_url) adImages.push(ad.image2_url);
                                if (ad.image3_url) adImages.push(ad.image3_url);
                                if (ad.image4_url) adImages.push(ad.image4_url);
                                if (ad.image5_url) adImages.push(ad.image5_url);
                                if (ad.image6_url) adImages.push(ad.image6_url);
                                if (ad.image7_url) adImages.push(ad.image7_url);

                                return (
                                    <tr key={ad?.id}>
                                        <td>{ad?.id}</td>
                                        <td>
                                            {adImages.length > 0 ? (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                                    {adImages.slice(0, 3).map((imageUrl, index) => (
                                                        <img
                                                            key={index}
                                                            src={`${MEDIA_SERVER_URL}/${imageUrl}`}
                                                            alt={`Ad image ${index + 1}`}
                                                            style={{
                                                                width: '50px',
                                                                height: '50px',
                                                                objectFit: 'cover',
                                                                cursor: 'pointer',
                                                                border: '1px solid #ddd'
                                                            }}
                                                            onClick={() => openImageModal(imageUrl, ad)}
                                                            title="Click to view image"
                                                        />
                                                    ))}
                                                    {adImages.length > 3 && (
                                                        <div style={{
                                                            fontSize: '10px',
                                                            color: '#007bff',
                                                            textAlign: 'center',
                                                            cursor: 'pointer'
                                                        }} onClick={() => openImageModal(adImages[0], ad)}>
                                                            +{adImages.length - 3} more
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span style={{ color: '#999', fontSize: '12px' }}>No images</span>
                                            )}
                                        </td>
                                        <td>
                                            {ad?.video_url && (
                                                <div style={{ position: 'relative' }}>
                                                    <video
                                                        width="50"
                                                        height="50"
                                                        style={{
                                                            cursor: 'pointer',
                                                            border: '1px solid #ddd',
                                                            borderRadius: '4px'
                                                        }}
                                                        onClick={() => openVideoModal(ad.video_url)}
                                                        title="Click to play video"
                                                    >
                                                        <source src={`${MEDIA_SERVER_URL}/${ad?.video_url}`} type="video/mp4" />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '2px',
                                                        right: '2px',
                                                        background: 'rgba(0,0,0,0.7)',
                                                        color: 'white',
                                                        fontSize: '8px',
                                                        padding: '1px 3px',
                                                        borderRadius: '3px'
                                                    }}>
                                                        ▶
                                                    </div>
                                                </div>
                                            )}
                                        </td>
                                        <td>{`${ad?.admin?.first_name} ${ad?.admin?.last_name}`}</td>
                                        <td>{ad?.title}</td>
                                        <td>
                                            {displayedContent}{" "}
                                            {shouldTruncate && (
                                                <span
                                                    onClick={() => toggleDescription(ad.id)}
                                                    style={{
                                                        color: "blue",
                                                        cursor: "pointer",
                                                        textDecoration: "underline",
                                                    }}
                                                >
                                                    {isExpanded ? "Show Less" : "Show More"}
                                                </span>
                                            )}
                                        </td>
                                        <td>{ad?.type}</td>
                                        <td>{new Date(ad?.createdAt).toLocaleString()}</td>
                                        <td>{new Date(ad?.end_time).toLocaleString()}</td>
                                        <td>
                                            <span style={{
                                                color: ad?.is_active ? 'green' : 'red',
                                                fontWeight: 'bold'
                                            }}>
                                                {ad?.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>{ad?.rank}</td>
                                        <td>{`${ad?.days}d ${ad?.hours}h ${ad?.minutes}m`}</td>
                                        <td>
                                            <div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
                                                <button
                                                    onClick={() => openModal(ad?.id)}
                                                    style={{
                                                        backgroundColor: '#ff4444',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '5px 10px',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Delete
                                                </button>

                                                <button
                                                    onClick={() => openRankedModal(ad)}
                                                    style={{
                                                        backgroundColor: '#007bff',
                                                        color: 'white',
                                                        border: 'none',
                                                        padding: '5px 10px',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}>
                                                    Edit
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )
                }
                {!thumbnailClicked && (
                    <>
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <button onClick={handleFirst} disabled={currentPage === 1}>
                                    First
                                </button>
                                <button onClick={handlePrevious} disabled={currentPage === 1}>
                                    Previous
                                </button>
                                {pageRange.map((page) => (
                                    <button
                                        key={page}
                                        onClick={() => handlePageClick(page)}
                                        style={{
                                            padding: "5px 10px",
                                            backgroundColor: currentPage === page ? "red" : "#f8f9fa",
                                            color: currentPage === page ? "white" : "black",
                                            border: "1px solid #ddd",
                                            cursor: "pointer",
                                        }}
                                    >
                                        {page}
                                    </button>
                                ))}
                                <button onClick={handleNext} disabled={currentPage === totalPages}>
                                    Next
                                </button>
                                <button onClick={handleLast} disabled={currentPage === totalPages}>
                                    Last
                                </button>
                            </div>
                            {/* direct page */}
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginLeft: '10px' }}>
                                <input
                                    type="number"
                                    value={inputPageNumber}
                                    onChange={(e) => setInputPageNumber(e.target.value)}
                                    placeholder="Page No"
                                    style={{
                                        padding: '5px',
                                        fontSize: '14px',
                                        // border: '1px solid #ccc',
                                        border: `2px solid ${inputFocus ? 'green' : '#ccc'}`,

                                        borderRadius: '4px 0 0 4px',
                                        outline: 'none',
                                        width: '90px'
                                    }}
                                    onFocus={() => setInputFocus(true)}
                                    onBlur={() => setInputFocus(false)}
                                />
                                <button
                                    onClick={handleGoToPage}
                                    style={{
                                        padding: '6.5px 10px',
                                        fontSize: '14px',
                                        border: '1px solid #ccc',
                                        borderLeft: 'none',
                                        borderRadius: '0 4px 4px 0',
                                        // backgroundColor: '#007bff',

                                        backgroundColor: `${buttonFocus ? 'green' : '#007bff'}`,
                                        color: 'white',
                                        cursor: 'pointer',
                                        outline: 'none',
                                    }}


                                >
                                    Go
                                </button>
                            </div>

                        </div>
                    </>
                )
                }


                {isrankedModalOpen && (
                    <Addranked
                        onClose={closeblockModal}
                        loading={loading}
                        onRanked={(totalSeconds, ranked, links, images, addlink, linktext) => handleRankedVideo(Selectedrankedvideoid, totalSeconds, ranked, links, images, addlink, linktext)}
                        adData={selectedAdForEdit}
                    />
                )}
                {
                    isprofilerankedModalOpen && (
                        <ProfileAddranked
                            onClose={closeblockModal}
                            loading={loading}
                            onRanked={(totalSeconds, ranked, links, images, addlink, linktext, username) => handleprofileRankedVideo(Selectedprofilerankedvideoid, totalSeconds, ranked, links, images, addlink, linktext, username)}

                        />
                    )
                }

                {
                    ShowAllCommentModel && (
                        <OpenCommeentModel
                            onClose={closeViewCommentModal}
                            loading={loading}
                            commentdata={CommentData}
                            HandleComment={HandleComment}
                            setIsEditModalOpen={setIsEditModalOpen}
                            isEditModalOpen={isEditModalOpen}
                            HandleCommentDelet={HandleCommentDelet}
                            isEditReplyCommentModalOpen={isEditReplyCommentModalOpen}
                            setisEditReplyCommentModalOpen={setisEditReplyCommentModalOpen}
                            HandleReplyComment={HandleReplyComment}
                            HandleCommentReplyDelete={HandleCommentReplyDelete}
                            hasSubFeatureEditvideocommet={hasSubFeatureEditvideocommet}
                            hasSubFeatureDeletevideocommet={hasSubFeatureDeletevideocommet}

                        />
                    )

                }
                {
                    isBlockModelOpen && (
                        <BlockVideoCommentModel
                            CloseModel={CloseModel}
                            FeatchUsers={FeatchUsers}
                            searchresult={searchresult}
                            onMute={handleCommentMuteUser}
                        />
                    )
                }

                {
                    isEditSectionModelOpen && (
                        <EditVideoSectionModel
                            CloseModel={CloseEditVideoInfoModel}
                            selectedvideoinfo={SelectedvideoId}

                            HandleEditVideoInfo={handleEditTitleAndDiscription}

                        />
                    )
                }
                <BlockVideoModal isOpen={IsBlockVideo} onClose={closeVideoBlockModal} blockvideohandler={blockvideohandler} />
                <MuteVideoAudioModal isOpen={IsBlockMuteVideoAudio} onClose={closeVideoAudioMuteModal} HandleMuteVideoAudio={HandleMuteVideoAudio} />

                {isModalOpen && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}>
                        <div style={{ background: 'white', padding: 24, borderRadius: 8, minWidth: 300 }}>
                            <h3>Delete Add</h3>
                            <p>Are you sure you want to delete this Add?</p>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                <button onClick={() => {
                                    closeModal();
                                }}>Cancel
                                </button>
                                <button onClick={() => handleDeleteAd(selectedAddId)}
                                    style={{ backgroundColor: 'darkred', color: 'white' }}>Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {isVideoModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        position: 'relative',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        background: 'black'
                    }}>
                        <button
                            onClick={closeVideoModal}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'red',
                                color: 'white',
                                border: 'none',
                                padding: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                zIndex: 10000
                            }}
                        >
                            Close
                        </button>
                        <video
                            controls
                            autoPlay
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                width: 'auto',
                                height: 'auto'
                            }}
                        >
                            <source
                                src={`${MEDIA_SERVER_URL}/${selectedVideoUrl}`}
                                type="video/mp4"
                            />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )}

            {/* Image Modal */}
            {isImageModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.9)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        position: 'relative',
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {/* Close Button */}
                        <button
                            onClick={closeImageModal}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '20px',
                                background: 'red',
                                color: 'white',
                                border: 'none',
                                padding: '10px 15px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                zIndex: 10000,
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}
                        >
                            ✕ Close
                        </button>

                        {/* Navigation Arrows (only show if multiple images) */}
                        {allAdImages.length > 1 && (
                            <>
                                <button
                                    onClick={prevImage}
                                    style={{
                                        position: 'absolute',
                                        left: '20px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'rgba(255,255,255,0.7)',
                                        color: 'black',
                                        border: 'none',
                                        padding: '15px 10px',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        zIndex: 10000,
                                        fontSize: '18px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ‹
                                </button>
                                <button
                                    onClick={nextImage}
                                    style={{
                                        position: 'absolute',
                                        right: '20px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'rgba(255,255,255,0.7)',
                                        color: 'black',
                                        border: 'none',
                                        padding: '15px 10px',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        zIndex: 10000,
                                        fontSize: '18px',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    ›
                                </button>
                            </>
                        )}

                        {/* Image Counter (only show if multiple images) */}
                        {allAdImages.length > 1 && (
                            <div style={{
                                position: 'absolute',
                                top: '20px',
                                left: '20px',
                                background: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                fontSize: '14px',
                                zIndex: 10000
                            }}>
                                {allAdImages.indexOf(selectedImageUrl) + 1} / {allAdImages.length}
                            </div>
                        )}

                        {/* Main Image */}
                        <img
                            src={`${MEDIA_SERVER_URL}/${selectedImageUrl}`}
                            alt="Ad content"
                            style={{
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                width: 'auto',
                                height: 'auto',
                                objectFit: 'contain'
                            }}
                            onClick={nextImage} // Click on image to go to next
                        />
                    </div>
                </div>
            )}
        </IncludeSideBar>
    );

}

export default Adds;

//  model for account deletion request

const TimePicker = ({ label, value, onChange }) => (
    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label style={{ flex: '1', textAlign: 'left' }}>{label}: </label>
        <input
            type="number"
            value={value}
            onChange={(e) => onChange(parseInt(e.target.value))}
            style={{
                width: '70px',
                padding: '10px',
                margin: '0 10px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                textAlign: 'center',
            }}
            min="0"
        />
    </div>
);

const Addranked = ({ onClose, onRanked, loading, adData }) => {

    const allVideoApis = require('../../../apis/all_user_video');
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState('style_01');
    const [solidColor, setSolidColor] = useState('#ffffff');
    const [isSetLoading, setLoading] = useState(false);
    const [overlayTexts, setOverlayTexts] = useState({
        image1_text: '',
        image2_text: '',
        image3_text: '',
        image4_text: '',
        image5_text: '',
        image6_text: '',
        image7_text: ''
    });
    const [ctaColor, setCtaColor] = useState(adData?.cta_color || '#007BFF');
    const [ctaWidth, setCtaWidth] = useState(adData?.cta_width || 120);

    const [addType, setAddType] = useState(adData?.type ? 'bg_picture' : 'bg_picture');
    const [rank, setRank] = useState(adData?.rank || '');
    const [addlink, setAddlink] = useState(adData?.cta_link || '');
    const [linktext, setLinktext] = useState(adData?.cta_text || '');
    const [hours, setHours] = useState(adData?.hours || 0);
    const [minutes, setMinutes] = useState(adData?.minutes || 0);
    const [seconds, setSeconds] = useState(adData?.seconds || 0);
    const [days, setDays] = useState(adData?.days || 0);

    const [templateConfig, setTemplateConfig] = useState({
        backgroundImage: null,
        backgroundVideo: null,
        overlayImages: {},
        overlayLinks: {}
    });

    // Template descriptions
    const templateOptions = [
        { value: 'style_01', label: 'Style 01 - Modern minimalist design with clean typography', number: 1 },
        { value: 'style_02', label: 'Style 02 - Bold and vibrant with gradient backgrounds', number: 2 },
        { value: 'style_03', label: 'Style 03 - Elegant and professional with subtle animations', number: 3 },
        { value: 'style_04', label: 'Style 04 - Playful and colorful with rounded elements', number: 4 },
        { value: 'style_05', label: 'Style 05 - Dark theme with neon accents', number: 5 },
        { value: 'style_06', label: 'Style 06 - Retro 80s inspired with geometric patterns', number: 6 },
        { value: 'style_07', label: 'Style 07 - Nature inspired with organic shapes', number: 7 },
        { value: 'style_08', label: 'Style 08 - Futuristic with metallic textures', number: 8 },
        { value: 'style_09', label: 'Style 09 - Artistic with brush stroke effects', number: 9 },
        { value: 'style_10', label: 'Style 10 - Corporate with clean lines and professional layout', number: 10 },
        { value: 'style_11', label: 'Style 11 - Gaming themed with pixel art elements', number: 11 },
        { value: 'style_12', label: 'Style 12 - Luxury with gold accents and serif fonts', number: 12 },
        { value: 'style_13', label: 'Style 13 - Minimalist with lots of white space', number: 13 },
        { value: 'style_14', label: 'Style 14 - Tech-inspired with circuit board patterns', number: 14 },
        { value: 'style_15', label: 'Style 15 - Romantic with soft colors and floral elements', number: 15 },
        { value: 'style_16', label: 'Style 16 - Sports themed with dynamic motion effects', number: 16 },
        { value: 'style_17', label: 'Style 17 - Urban with graffiti and street art style', number: 17 },
        { value: 'style_18', label: 'Style 18 - Beach themed with tropical colors', number: 18 },
        { value: 'style_19', label: 'Style 19 - Winter with cool colors and snow effects', number: 19 },
        { value: 'style_20', label: 'Style 20 - Abstract with geometric patterns and bold colors', number: 20 }
    ];

    const getTemplateNumber = () => {
        const template = templateOptions.find(opt => opt.value === selectedTemplate);
        return template ? template.number : 1;
    };

    const modalTitle = adData ? 'Edit Add' : 'Create Add';
    const createAdd = async (formData) => {
        const response = await allVideoApis.createAdd(formData);
        console.log(response);
        return response;
    };

    const editAdd = async (formData, id) => {
        const response = await allVideoApis.editAdd(formData, id);
        console.log(response);
        return response;
    };

    const handleCreateAdd = async () => {

        const totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

        const end_date = new Date(Date.now() + totalSeconds * 1000).toISOString();

        const templateNumber = getTemplateNumber();

        const formData = new FormData();

        // Append basic fields
        formData.append('title', `Ad Template ${selectedTemplate}`);
        formData.append('content', `Advertisement created with template ${selectedTemplate}`);
        formData.append('type', templateNumber.toString());
        formData.append('end_date', end_date);
        formData.append('cta_text', linktext);
        formData.append('cta_link', addlink);
        formData.append('cta_color', ctaColor);
        formData.append('cta_width', ctaWidth.toString());
        formData.append('days', days.toString());
        formData.append('hours', hours.toString());
        formData.append('minutes', minutes.toString());
        formData.append('rank', rank);

        if (addType === 'bg_solid_color') {
            formData.append('background_color', solidColor.replace('#', ''));
        } else {

            if (templateConfig.backgroundImage) {
                formData.append('images', templateConfig.backgroundImage);
            }
            if (templateConfig.backgroundVideo) {
                formData.append('video', templateConfig.backgroundVideo);
            }
        }

        Object.keys(templateConfig.overlayImages).forEach((overlayNumber, index) => {
            const overlayImage = templateConfig.overlayImages[overlayNumber];
            const overlayLink = templateConfig.overlayLinks[overlayNumber];
            const overlayText = templateConfig.overlayTexts?.[overlayNumber] || '';

            if (overlayImage) {
                formData.append('images', overlayImage);
            }

            if (overlayLink) {
                formData.append(`ext_image${overlayNumber}_link`, overlayLink);
            }

            if (overlayText) {
                formData.append(`image${overlayNumber}_text`, overlayText);
            }
        });

        // Log form data for debugging
        console.log('FormData contents:');
        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        if (adData) {
            console.log('Editing ad:', adData.id);
            try {
                setLoading(true);
                const result = await editAdd(formData, adData.id);

                if (result.success) {
                    alert('Ad updated successfully!');
                    onClose();
                } else {
                    console.log(`response ${JSON.stringify(result)}`)
                    alert(`Failed to update ad: ${result.message}`);
                }
            } catch (error) {
                console.error('Error updating ad:', error);
                alert('Error updating ad. Please try again.');
            } finally {
                setLoading(false);
            }
        } else {

            try {
                setLoading(true);
                const result = await createAdd(formData);

                if (result.success) {
                    alert('Ad created successfully!');
                    onClose();
                } else {
                    console.log(`response ${JSON.stringify(result)}`)
                    alert(`Failed to create ad: ${result.message}`);
                }
            } catch (error) {
                console.error('Error creating ad:', error);
                alert('Error creating ad. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    };

    const openTemplateModal = (adData = null, ctaWidth = null, ctaColor = null) => {
        // console.log("temp", adData)
        setShowTemplateModal(true);
    };

    const closeTemplateModal = () => {
        setShowTemplateModal(false);
    };

    const handleTemplateSelect = (template) => {
        setSelectedTemplate(template);
    };

    const handleTemplateConfig = (config) => {
        setTemplateConfig(config);
        closeTemplateModal();
    };

    const modalStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: '1000',
    };

    const modalContentStyles = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        width: '600px',
        maxHeight: '80vh',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        overflowY: 'auto',
    };

    const inputStyles = {
        width: 'calc(50% - 10px)',
        padding: '10px',
        margin: '0 5px',
        borderRadius: '5px',
        border: '1px solid #ccc',
    };

    const selectStyles = {
        width: '100%',
        padding: '10px',
        margin: '10px 0',
        borderRadius: '5px',
        border: '1px solid #ccc',
    };

    const buttonStyles = {
        backgroundColor: '#007BFF',
        color: 'white',
        padding: '10px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const buttonCancelStyles = {
        backgroundColor: '#6c757d',
        color: 'white',
        padding: '10px 20px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const colorInputStyles = {
        width: '100%',
        padding: '5px',
        margin: '10px 0',
        borderRadius: '5px',
        border: '1px solid #ccc',
        height: '40px',
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <h2 style={{ color: 'red', marginBottom: '20px' }}>{modalTitle}</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}

                <div style={{ marginBottom: '20px' }}>
                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Add Type:</label>
                    <select
                        value={addType}
                        onChange={(e) => setAddType(e.target.value)}
                        style={selectStyles}>
                        <option value="bg_picture">Background Picture</option>
                        <option value="bg_solid_color">Background Solid Color</option>
                    </select>
                </div>

                {addType === 'bg_solid_color' && (
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Background Color:</label>
                        <input
                            type="color"
                            value={solidColor}
                            onChange={(e) => setSolidColor(e.target.value)}
                            style={colorInputStyles}
                        />
                    </div>
                )}

                <p style={{ marginBottom: '20px' }}>Select the duration for the add</p>
                <TimePicker label="Days" value={days} onChange={setDays} />
                <TimePicker label="Hours" value={hours} onChange={setHours} />
                <TimePicker label="Minutes" value={minutes} onChange={setMinutes} />
                <TimePicker label="Seconds" value={seconds} onChange={setSeconds} />

                <input
                    type="text"
                    value={addlink}
                    onChange={(e) => setAddlink(e.target.value)}
                    placeholder="Button Link"
                    style={{ ...inputStyles, width: '100%', margin: '0 0 10px 0' }}
                />
                <input
                    type="text"
                    value={linktext}
                    onChange={(e) => setLinktext(e.target.value)}
                    placeholder="Button Text"
                    maxLength={10}
                    style={{ ...inputStyles, width: '100%', margin: '0 0 10px 0' }}
                />
                <input
                    type="text"
                    value={rank}
                    onChange={(e) => setRank(e.target.value)}
                    placeholder="Rank"
                    style={{ ...inputStyles, width: '100%', margin: '0 0 10px 0' }}
                />

                <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
                    <h3 style={{ marginBottom: '15px' }}>Buy Button Customization</h3>

                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Button Color:</label>
                        <input
                            type="color"
                            value={ctaColor}
                            onChange={(e) => setCtaColor(e.target.value)}
                            style={colorInputStyles}
                        />
                    </div>

                    <div style={{ marginBottom: '10px' }}>
                        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Button Width (px):</label>
                        <input
                            type="number"
                            value={ctaWidth}
                            onChange={(e) => setCtaWidth(parseInt(e.target.value) || 120)}
                            min="50"
                            max="300"
                            style={{ ...inputStyles, width: '100px' }}
                        />
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                        <div style={{
                            backgroundColor: ctaColor,
                            color: 'white',
                            padding: '10px 20px',
                            borderRadius: '25px',
                            display: 'inline-block',
                            width: `${ctaWidth}px`,
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontSize: '12px'
                        }}>
                            {linktext || 'Buy Now'}
                        </div>
                    </div>
                </div>

                {templateConfig.backgroundImage || templateConfig.backgroundVideo ? (
                    <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#d4edda', borderRadius: '5px' }}>
                        <p style={{ color: '#155724', margin: 0 }}>
                            ✓ Template {getTemplateNumber()} configured with {templateConfig.backgroundImage ? 'image' : 'video'} background
                            {Object.keys(templateConfig.overlayImages).length > 0 &&
                                ` and ${Object.keys(templateConfig.overlayImages).length} overlay(s)`}
                        </p>
                    </div>
                ) : (
                    <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8d7da', borderRadius: '5px' }}>
                        <p style={{ color: '#721c24', margin: 0 }}>
                            ⚠ No template selected. Please choose a template.
                        </p>
                    </div>
                )}

                <button
                    style={{ ...buttonStyles, backgroundColor: '#28a745', width: '100%' }}
                    onClick={() => openTemplateModal(adData, ctaWidth, ctaColor)}>
                    {templateConfig.backgroundImage || templateConfig.backgroundVideo ? 'Change Template' : 'Choose Template'}
                </button>

                <button
                    style={!isSetLoading ? buttonStyles : { opacity: .5 }}
                    onClick={handleCreateAdd}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#007BFF')}
                    disabled={isSetLoading}>
                    {!isSetLoading ? modalTitle : 'Loading...'}
                </button>

                <button
                    style={buttonCancelStyles}
                    onClick={onClose}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}>
                    Cancel
                </button>
            </div>

            {/* Template Selection Modal */}
            {
                showTemplateModal && (
                    <TemplateModal
                        onClose={closeTemplateModal}
                        selectedTemplate={selectedTemplate}
                        onTemplateSelect={handleTemplateSelect}
                        templateOptions={templateOptions}
                        onTemplateConfig={handleTemplateConfig}
                        ctaWidth={ctaWidth}
                        ctaColor={ctaColor}
                        adData={adData}
                    />
                )
            }
        </div >
    );
};

// Template Modal Component
const TemplateModal = ({ onClose, selectedTemplate, onTemplateSelect, templateOptions, onTemplateConfig, ctaWidth, addData, ctaColor }) => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedOverlayImage, setSelectedOverlayImage] = useState(null);
    const [selectedOverlayImage2, setSelectedOverlayImage2] = useState(null);
    const [selectedOverlayImage3, setSelectedOverlayImage3] = useState(null);
    const [selectedOverlayImage4, setSelectedOverlayImage4] = useState(null);
    const [selectedOverlayImage5, setSelectedOverlayImage5] = useState(null);
    const [selectedOverlayImage6, setSelectedOverlayImage6] = useState(null);
    const [overlayLinks, setOverlayLinks] = useState({});
    const [editingLink, setEditingLink] = useState(null);
    const [linkInputValue, setLinkInputValue] = useState('');
    const fileInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const overlayInputRef = useRef(null);
    const overlayInputRef2 = useRef(null);
    const overlayInputRef3 = useRef(null);
    const overlayInputRef4 = useRef(null);
    const overlayInputRef5 = useRef(null);
    const overlayInputRef6 = useRef(null);
    const [overlayTexts, setOverlayTexts] = useState({
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
        6: ''
    });
    const [editingText, setEditingText] = useState(null);
    const [textInputValue, setTextInputValue] = useState('');

    const linkManagementStyles = {
        position: 'absolute',
        top: '2px',
        left: '2px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        border: 'none',
        padding: '2px 6px',
        borderRadius: '10px',
        fontSize: '8px',
        cursor: 'pointer',
        zIndex: 25,
        display: 'flex',
        alignItems: 'center',
        gap: '2px'
    };

    const linkIconStyles = {
        fontSize: '8px',
        fontWeight: 'bold'
    };

    const linkModalStyles = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        zIndex: 2000,
        minWidth: '300px'
    };

    const linkInputStyles = {
        width: '100%',
        padding: '8px',
        margin: '10px 0',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '14px'
    };

    const linkButtonStyles = {
        padding: '8px 16px',
        margin: '5px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px'
    };

    const modalStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: '1001',
    };

    const modalContentStyles = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '80vh',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        overflowY: 'auto',
    };

    const selectStyles = {
        width: '100%',
        padding: '10px',
        margin: '20px 0',
        borderRadius: '5px',
        border: '1px solid #ccc',
        fontSize: '16px',
    };

    const phoneContainerStyles = {
        width: '320px',
        height: '568px',
        border: '2px solid #333',
        borderRadius: '20px',
        margin: '20px auto',
        padding: '10px',
        backgroundColor: '#f5f5f5',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    };

    const phoneScreenStyles = {
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: '10px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    };

    const placeholderImageStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '10px',
    };

    const videoStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '10px',
    };

    const backgroundPlaceholderStyles = {
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa',
    };

    const overlayContainerStyles = {
        position: 'absolute',
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 15,
        overflow: 'hidden',
    };

    const overlayImageStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '6px',
    };

    const skipButtonStyles = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '15px',
        fontSize: '10px',
        fontWeight: 'bold',
        cursor: 'pointer',
        zIndex: 20,
        minWidth: '60px',
    };

    const buyNowButtonStyles = {
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: ctaColor,
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        width: `${ctaWidth}px`,
        borderRadius: '25px',
        fontSize: '12px',
        fontWeight: 'bold',
        cursor: 'pointer',
        zIndex: 20,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
    };

    const uploadButtonStyles = {
        backgroundColor: '#28a745',
        color: 'white',
        padding: '8px 16px',
        margin: '5px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '12px',
    };

    const buttonStyles = {
        backgroundColor: '#007BFF',
        color: 'white',
        padding: '10px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    };

    const removeButtonStyles = {
        backgroundColor: '#6c757d',
        color: 'white',
        padding: '8px 16px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
    };

    const placeholderUrl = `https://placehold.co/320x568`;

    const handleTextButtonClick = (e, overlayNumber) => {
        e.stopPropagation();
        setEditingText(overlayNumber);
        setTextInputValue(overlayTexts[overlayNumber] || '');
    };

    const handleSaveText = () => {
        if (editingText && textInputValue.trim()) {
            setOverlayTexts(prev => ({
                ...prev,
                [editingText]: textInputValue.trim()
            }));
        }
        setEditingText(null);
        setTextInputValue('');
    };

    const handleCancelTextEdit = () => {
        setEditingText(null);
        setTextInputValue('');
    };

    const handleBackgroundClick = () => {
        if (selectedTemplate === 'style_02') {
            const choice = window.confirm('Style 2 supports background video. Click OK to upload video, Cancel to upload image.');
            if (choice) {
                videoInputRef.current?.click();
            } else {
                fileInputRef.current?.click();
            }
        } else {
            fileInputRef.current?.click();
        }
    };

    const handleLinkButtonClick = (e, overlayNumber) => {
        e.stopPropagation();
        setEditingLink(overlayNumber);
        setLinkInputValue(overlayLinks[overlayNumber] || '');
    };

    const handleSaveLink = () => {
        if (editingLink && linkInputValue.trim()) {
            setOverlayLinks(prev => ({
                ...prev,
                [editingLink]: linkInputValue.trim()
            }));
        }
        setEditingLink(null);
        setLinkInputValue('');
    };

    const handleRemoveLink = (overlayNumber) => {
        setOverlayLinks(prev => {
            const newLinks = { ...prev };
            delete newLinks[overlayNumber];
            return newLinks;
        });
        setEditingLink(null);
        setLinkInputValue('');
    };

    const handleCancelEdit = () => {
        setEditingLink(null);
        setLinkInputValue('');
    };

    const handleOverlayClick = (e, overlayNumber = 1) => {
        if (overlayLinks[overlayNumber] && !editingLink) {
            e.preventDefault();
            e.stopPropagation();
            window.open(overlayLinks[overlayNumber], '_blank');
            return;
        }

        e.stopPropagation();
        const refs = {
            1: overlayInputRef,
            2: overlayInputRef2,
            3: overlayInputRef3,
            4: overlayInputRef4,
            5: overlayInputRef5,
            6: overlayInputRef6
        };
        refs[overlayNumber]?.current?.click();
    };

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setSelectedImage(e.target.result);
                setSelectedVideo(null);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please select a valid image file.');
        }
    };

    const handleVideoSelect = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('video/')) {
            const videoUrl = URL.createObjectURL(file);
            setSelectedVideo(videoUrl);
            setSelectedImage(null);
        } else {
            alert('Please select a valid video file.');
        }
    };

    const handleOverlayImageSelect = (event, overlayNumber = 1) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const setters = {
                    1: setSelectedOverlayImage,
                    2: setSelectedOverlayImage2,
                    3: setSelectedOverlayImage3,
                    4: setSelectedOverlayImage4,
                    5: setSelectedOverlayImage5,
                    6: setSelectedOverlayImage6
                };
                setters[overlayNumber]?.(e.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please select a valid image file.');
        }
    };

    const handleRemoveBackground = () => {
        setSelectedImage(null);
        setSelectedVideo(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
        if (videoInputRef.current) videoInputRef.current.value = '';
    };

    const handleRemoveOverlay = (overlayNumber = 1) => {
        const setters = {
            1: setSelectedOverlayImage,
            2: setSelectedOverlayImage2,
            3: setSelectedOverlayImage3,
            4: setSelectedOverlayImage4,
            5: setSelectedOverlayImage5,
            6: setSelectedOverlayImage6
        };
        const refs = {
            1: overlayInputRef,
            2: overlayInputRef2,
            3: overlayInputRef3,
            4: overlayInputRef4,
            5: overlayInputRef5,
            6: overlayInputRef6
        };

        setters[overlayNumber]?.(null);
        if (refs[overlayNumber]?.current) refs[overlayNumber].current.value = '';
    };

    const handleUploadImage = () => fileInputRef.current?.click();
    const handleUploadVideo = () => videoInputRef.current?.click();

    const handleUploadOverlay = (overlayNumber = 1) => {
        const refs = {
            1: overlayInputRef,
            2: overlayInputRef2,
            3: overlayInputRef3,
            4: overlayInputRef4,
            5: overlayInputRef5,
            6: overlayInputRef6
        };
        refs[overlayNumber]?.current?.click();
    };

    const isStyle2 = selectedTemplate === 'style_02';
    const isStyle3 = selectedTemplate === 'style_03';
    const isStyle4 = selectedTemplate === 'style_04';
    const isStyle5 = selectedTemplate === 'style_05';
    const isStyle6 = selectedTemplate === 'style_06';
    const isStyle7 = selectedTemplate === 'style_07';
    const isStyle8 = selectedTemplate === 'style_08';
    const isStyle9 = selectedTemplate === 'style_09';
    const isStyle10 = selectedTemplate === 'style_10';
    const isStyle11 = selectedTemplate === 'style_11';
    const isStyle12 = selectedTemplate === 'style_12';
    const isStyle13 = selectedTemplate === 'style_13';
    const isStyle14 = selectedTemplate === 'style_14';
    const isStyle15 = selectedTemplate === 'style_15';
    const isStyle16 = selectedTemplate === 'style_16';
    const isStyle17 = selectedTemplate === 'style_17';
    const isStyle18 = selectedTemplate === 'style_18';
    const isStyle19 = selectedTemplate === 'style_19';
    const isStyle20 = selectedTemplate === 'style_20';

    const hasBackgroundMedia = selectedImage || selectedVideo;
    const hasOverlayImage = selectedOverlayImage;
    const hasOverlayImage2 = selectedOverlayImage2;
    const hasOverlayImage3 = selectedOverlayImage3;
    const hasOverlayImage4 = selectedOverlayImage4;

    const hasOverlaySupport = isStyle3 || isStyle4 || isStyle5 || isStyle6 || isStyle7 || isStyle8 || isStyle9 || isStyle10 || isStyle11 || isStyle12 || isStyle13 || isStyle14 || isStyle15 || isStyle16 || isStyle17 || isStyle18 || isStyle19 || isStyle20;
    const hasMultipleOverlays = isStyle6 || isStyle7 || isStyle8 || isStyle9 || isStyle10 || isStyle11 || isStyle12 || isStyle13 || isStyle14 || isStyle15 || isStyle16 || isStyle17 || isStyle18 || isStyle19 || isStyle20;
    const hasThreeOverlays = isStyle9 || isStyle10 || isStyle11;
    const hasFourOverlays = isStyle12 || isStyle13 || isStyle14;
    const hasFiveOverlays = isStyle15 || isStyle16 || isStyle17;
    const hasSixOverlays = isStyle18 || isStyle19 || isStyle20;

    const hasOverlayImage5 = selectedOverlayImage5;
    const hasOverlayImage6 = selectedOverlayImage6;

    // Get overlay container style based on template
    const getOverlayContainerStyle = (overlayNumber = 1) => {
        const baseStyle = { ...overlayContainerStyles };

        if (isStyle3) {
            return { ...baseStyle, width: '220px', height: '130px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#dc3545' };
        }
        if (isStyle4) {
            return { ...baseStyle, width: '220px', height: '220px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#6610f2' };
        }
        if (isStyle5) {
            return { ...baseStyle, width: '200px', height: '400px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#20c997' };
        }
        if (isStyle6) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '200px', height: '200px', top: '10%', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '200px', height: '200px', top: '48%', left: '50%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
        }
        if (isStyle7) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '220px', top: '15%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#e83e8c' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '220px', top: '15%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#e83e8c' };
            }
        }
        if (isStyle8) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '250px', top: '15%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#e83e8c' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '250px', top: '15%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#e83e8c' };
            }
        }
        if (isStyle9) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '180px', top: '15%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '180px', top: '15%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '180px', top: '65%', left: '52%', transform: 'translate(-50%, -50%)', backgroundColor: '#17a2b8' };
            }
        }
        if (isStyle10) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '180px', top: '15%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '180px', top: '15%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '260px', height: '180px', top: '65%', left: '52%', transform: 'translate(-50%, -50%)', backgroundColor: '#17a2b8' };
            }
        }
        if (isStyle11) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '120px', height: '130px', top: '20%', left: '32%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '120px', height: '130px', top: '45%', left: '32%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '120px', height: '265px', top: '20%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
        }
        if (isStyle12) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '120px', height: '100px', top: '15%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ff6b6b' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '120px', height: '100px', top: '35%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ff6b6b' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '120px', height: '100px', top: '55%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ff6b6b' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '120px', height: '320px', top: '15%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#ff6b6b' };
            }
        }
        if (isStyle13) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '200px', top: '13%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#20c997' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '200px', top: '50%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#20c997' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '200px', top: '13%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#20c997' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '130px', height: '200px', top: '50%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#20c997' };
            }
        }
        if (isStyle14) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '200px', top: '13%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '200px', top: '50%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '200px', top: '8%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '130px', height: '200px', top: '46%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
        }
        if (isStyle15) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '110px', top: '19%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ffc107' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '110px', top: '40%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ffc107' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '110px', top: '61%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#ffc107' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '130px', height: '200px', top: '13%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#ffc107' };
            }
            if (overlayNumber === 5) {
                return { ...baseStyle, width: '130px', height: '200px', top: '50%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#ffc107' };
            }
        }
        if (isStyle16) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '180px', top: '10%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#dc3545' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '100px', top: '44%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#dc3545' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '120px', top: '10%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#dc3545' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '130px', height: '160px', top: '33%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#dc3545' };
            }
            if (overlayNumber === 5) {
                return { ...baseStyle, width: '260px', height: '130px', top: '76%', left: '52%', transform: 'translate(-50%, -50%)', backgroundColor: '#dc3545' };
            }
        }
        if (isStyle17) {
            const columnWidth = 50;
            const leftPosition = 15 + (overlayNumber - 1) * (18);
            return { ...baseStyle, width: `${columnWidth}px`, height: '400px', top: '50%', left: `${leftPosition}%`, transform: 'translate(-50%, -50%)', backgroundColor: '#20c997' };
        }
        if (isStyle18) {
            const circularStyle = { ...baseStyle, borderRadius: '50%' };
            if (overlayNumber <= 3) {
                const topPosition = 10 + (overlayNumber - 1) * 30;
                return { ...circularStyle, width: '130px', height: '130px', top: `${topPosition}%`, left: '30%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            } else {
                const topPosition = 10 + (overlayNumber - 4) * 30;
                return { ...circularStyle, width: '130px', height: '130px', top: `${topPosition}%`, left: '75%', transform: 'translateX(-50%)', backgroundColor: '#6f42c1' };
            }
        }
        if (isStyle19) {
            if (overlayNumber === 1) {
                return { ...baseStyle, width: '130px', height: '110px', top: '10%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 2) {
                return { ...baseStyle, width: '130px', height: '100px', top: '31%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 3) {
                return { ...baseStyle, width: '130px', height: '90px', top: '50%', left: '30%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 4) {
                return { ...baseStyle, width: '130px', height: '110px', top: '10%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 5) {
                return { ...baseStyle, width: '130px', height: '194px', top: '31%', left: '75%', transform: 'translateX(-50%)', backgroundColor: '#fd7e14' };
            }
            if (overlayNumber === 6) {
                return { ...baseStyle, width: '260px', height: '110px', top: '78%', left: '52%', transform: 'translate(-50%, -50%)', backgroundColor: '#fd7e14' };
            }
        }
        if (isStyle20) {
            if (overlayNumber <= 3) {
                const heights = [140, 80, 140];
                const topPositions = [10, 36, 51];
                return { ...baseStyle, width: '130px', height: `${heights[overlayNumber - 1]}px`, top: `${topPositions[overlayNumber - 1]}%`, left: '30%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            } else {
                const heights = [120, 80, 150];
                const topPositions = [10, 33, 49];
                return { ...baseStyle, width: '130px', height: `${heights[overlayNumber - 4]}px`, top: `${topPositions[overlayNumber - 4]}%`, left: '75%', transform: 'translateX(-50%)', backgroundColor: '#17a2b8' };
            }
        }
        return baseStyle;
    };

    const getTextContainerStyle = (overlayNumber = 1) => {
        const baseStyle = {
            position: 'absolute',
            width: '130px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2px',
            color: '#000',
            fontWeight: 'bold',
            zIndex: 15,
            background: '#ccc',
            borderRadius: '0 0 8px 8px',
            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
            pointerEvents: 'none',
        };
        if (overlayNumber === 1) {
            return { ...baseStyle, top: '42.2%', left: '30%', transform: 'translateX(-50%)' };
        }
        if (overlayNumber === 2) {
            return { ...baseStyle, top: '79.3%', left: '30%', transform: 'translateX(-50%)' };
        }
        if (overlayNumber === 3) {
            return { ...baseStyle, top: '37.4%', left: '75%', transform: 'translateX(-50%)' };
        }
        if (overlayNumber === 4) {
            return { ...baseStyle, top: '75.3%', left: '75%', transform: 'translateX(-50%)' };
        }
        return baseStyle;
    };

    const getOverlayPlaceholderUrl = (overlayNumber = 1) => {
        if (isStyle3) return `https://placehold.co/220x130`;
        if (isStyle4) return `https://placehold.co/220x220`;
        if (isStyle5) return `https://placehold.co/200x400`;
        if (isStyle6) return `https://placehold.co/200x200`;
        if (isStyle7) return `https://placehold.co/130x220`;
        if (isStyle8) return `https://placehold.co/130x250`;
        if (isStyle9) return `https://placehold.co/130x250`;
        if (isStyle10) {
            if (overlayNumber === 3) return `https://placehold.co/260x120`;
            return `https://placehold.co/130x180`;
        }
        if (isStyle11) {
            if (overlayNumber === 3) return `https://placehold.co/120x260`;
            return `https://placehold.co/120x130`;
        }
        if (isStyle12) {
            if (overlayNumber === 4) return `https://placehold.co/120x320`;
            return `https://placehold.co/120x100`;
        }
        if (isStyle13 || isStyle14) return `https://placehold.co/130x200`;
        if (isStyle15) {
            if (overlayNumber <= 3) return `https://placehold.co/110x130`;
            return `https://placehold.co/130x200`;
        }
        if (isStyle16) {
            if (overlayNumber === 1) return `https://placehold.co/130x180`;
            if (overlayNumber === 2) return `https://placehold.co/130x100`;
            if (overlayNumber === 3) return `https://placehold.co/130x120`;
            if (overlayNumber === 4) return `https://placehold.co/130x160`;
            if (overlayNumber === 5) return `https://placehold.co/260x130`;
        }
        if (isStyle17) return `https://placehold.co/50x400`;
        if (isStyle18) return `https://placehold.co/130x130`;
        if (isStyle19) {
            if (overlayNumber === 1) return `https://placehold.co/130x110`;
            if (overlayNumber === 2) return `https://placehold.co/130x100`;
            if (overlayNumber === 3) return `https://placehold.co/130x90`;
            if (overlayNumber === 4) return `https://placehold.co/130x110`;
            if (overlayNumber === 5) return `https://placehold.co/130x194`;
            if (overlayNumber === 6) return `https://placehold.co/260x110`;
        }
        if (isStyle20) {
            if (overlayNumber === 1) return `https://placehold.co/130x140`;
            if (overlayNumber === 2) return `https://placehold.co/130x80`;
            if (overlayNumber === 3) return `https://placehold.co/130x140`;
            if (overlayNumber === 4) return `https://placehold.co/130x120`;
            if (overlayNumber === 5) return `https://placehold.co/130x80`;
            if (overlayNumber === 6) return `https://placehold.co/130x150`;
        }
        return '';
    };

    // Get overlay upload button style based on template
    const getOverlayUploadButtonStyle = (overlayNumber = 1) => {

        const baseStyle = {
            padding: '6px 12px',
            margin: '5px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '11px',
            fontWeight: 'bold',
            color: 'white'
        };

        if (isStyle3) return { ...baseStyle, backgroundColor: '#dc3545' };
        if (isStyle4) return { ...baseStyle, backgroundColor: '#6610f2' };
        if (isStyle5) return { ...baseStyle, backgroundColor: '#20c997' };
        if (isStyle6) return { ...baseStyle, backgroundColor: '#fd7e14' };
        if (isStyle7) return { ...baseStyle, backgroundColor: '#e83e8c' };
        if (isStyle8) return { ...baseStyle, backgroundColor: '#fe9e8c' };
        if (isStyle9) return { ...baseStyle, backgroundColor: '#17a2b8' };
        if (isStyle10) return { ...baseStyle, backgroundColor: '#343a40' };
        if (isStyle11) return { ...baseStyle, backgroundColor: '#6f42c1' };
        if (isStyle12) return { ...baseStyle, backgroundColor: '#ff6b6b' };
        if (isStyle13) return { ...baseStyle, backgroundColor: '#9f43c1' };
        if (isStyle14) return { ...baseStyle, backgroundColor: '#6f42c1' };
        if (isStyle15) return { ...baseStyle, backgroundColor: '#ffc107' };
        if (isStyle16) return { ...baseStyle, backgroundColor: '#dc3545' };
        if (isStyle17) return { ...baseStyle, backgroundColor: '#20c997' };
        if (isStyle18) return { ...baseStyle, backgroundColor: '#6f42c1' };
        if (isStyle19) return { ...baseStyle, backgroundColor: '#fd7e14' };
        if (isStyle20) return { ...baseStyle, backgroundColor: '#17a2b8' };
        return baseStyle;
    };

    const textOverlayStyles = {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        height: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px',
        textAlign: 'center',
        color: '#000',
        fontWeight: 'bold',
        zIndex: 5,
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0.52) 100%)',
        borderRadius: '6px',
        pointerEvents: 'none',
    };

    const textManagementStyles = {
        position: 'absolute',
        top: '2px',
        right: '2px',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        color: 'white',
        border: 'none',
        padding: '2px 6px',
        borderRadius: '10px',
        fontSize: '8px',
        cursor: 'pointer',
        zIndex: 25,
        display: 'flex',
        alignItems: 'center',
        gap: '2px'
    };

    const textIconStyles = {
        fontSize: '8px',
        fontWeight: 'bold'
    };

    const textModalStyles = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
        zIndex: 2000,
        minWidth: '300px'
    };

    const textInputStyles = {
        width: '100%',
        padding: '8px',
        margin: '10px 0',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '14px',
        minHeight: '80px',
        resize: 'vertical'
    };

    const line1Style = { fontSize: '8px', marginBottom: '2px', lineHeight: '1.1', };

    const getOverlayTextContent = (overlayNumber = 1) => {
        switch (overlayNumber) {
            case 1:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            case 2:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            case 3:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            case 4:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            case 5:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            case 6:
                return (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>This text is a placeholder created only for testing display. Do not use as</div>
                    </div>
                );
            default:
                return null;
        }
    };

    const OverlayContainerWithText = ({ overlayNumber, hasImage, imageSrc, placeholderUrl, onClick, title }) => {
        return (
            <div
                style={getOverlayContainerStyle(overlayNumber)}
                onClick={onClick}
                title={title}>
                <img
                    src={hasImage ? imageSrc : placeholderUrl}
                    alt={hasImage ? `Overlay ${overlayNumber}` : `Overlay ${overlayNumber} placeholder`}
                    style={overlayImageStyles}
                />
                {/* Text Overlay - Always visible on top of the image */}
                {getOverlayTextContent(overlayNumber)}
            </div>
        );
    };

    // Text content for each overlay in Style 14
    const getTextContent = (overlayNumber = 1) => {
        const textStyle = {
            fontSize: '8px',
            fontWeight: 'bold',
            color: '#000',
            textAlign: 'center',
            lineHeight: '1.2',
        };

        switch (overlayNumber) {
            case 1:
                return <div style={textStyle}>Premium Quality Product Premium Quality Product Premium Quality Product</div>;
            case 2:
                return <div style={textStyle}>Premium Quality Product Premium Quality Product Premium Quality Product</div>;
            case 3:
                return <div style={textStyle}>Premium Quality Product Premium Quality Product Premium Quality Product</div>;
            case 4:
                return <div style={textStyle}>Premium Quality Product Premium Quality Product Premium Quality Product</div>;
            default:
                return null;
        }
    };

    // Overlay container with separate text for Style 14
    const OverlayContainerWithSeparateText = ({ overlayNumber, hasImage, imageSrc, placeholderUrl, onClick, title }) => {
        return (
            <>
                {/* Image Container */}
                <div
                    style={getOverlayContainerStyle(overlayNumber)}
                    onClick={onClick}
                    title={title}
                >
                    <img
                        src={hasImage ? imageSrc : placeholderUrl}
                        alt={hasImage ? `Overlay ${overlayNumber}` : `Overlay ${overlayNumber} placeholder`}
                        style={overlayImageStyles}
                    />
                </div>
                {/* Separate Text Container Below Image */}
                <div style={getTextContainerStyle(overlayNumber)}>
                    {getTextContent(overlayNumber)}
                </div>
            </>
        );
    };

    const OverlayContainerWithLinkAndText = ({
        overlayNumber,
        hasImage,
        imageSrc,
        placeholderUrl,
        onClick,
        title,
        hasLink,
        onLinkClick,
        hasText,
        onTextClick,
        textContent,
        hasOverlayText = true,
        showText = true,
    }) => {
        return (
            <div
                style={getOverlayContainerStyle(overlayNumber)}
                onClick={onClick}
                title={hasLink ? `Click to visit: ${overlayLinks[overlayNumber]}` : title}>
                <img
                    src={hasImage ? imageSrc : placeholderUrl}
                    alt={hasImage ? `Overlay ${overlayNumber}` : `Overlay ${overlayNumber} placeholder`}
                    style={overlayImageStyles}
                />

                {hasImage && (
                    <button
                        style={linkManagementStyles}
                        onClick={onLinkClick}
                        title={hasLink ? `Edit link: ${overlayLinks[overlayNumber]}` : "Add link to this overlay"}>
                        <span style={linkIconStyles}>🔗</span>
                        {hasLink ? '✓' : '+'}
                    </button>
                )}

                {hasImage && showText && (
                    <button
                        style={textManagementStyles}
                        onClick={onTextClick}
                        title={hasText ? `Edit text: ${textContent}` : "Add text to this overlay"}>
                        <span style={textIconStyles}>📝</span>
                        {hasText ? '✓' : '+'}
                    </button>
                )}

                {showText && hasOverlayText && (
                    <div style={textOverlayStyles}>
                        <div style={line1Style}>
                            {textContent || 'Click the 📝 icon to add text'}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Render overlay containers based on template
    const renderOverlayContainers = () => {
        if (!hasOverlaySupport) return null;

        const templatesWithTextEditing = [
            'style_12', 'style_13', 'style_14', 'style_15',
            'style_16', 'style_17', 'style_18', 'style_19', 'style_20'
        ];

        const showTextForThisTemplate = templatesWithTextEditing.includes(selectedTemplate);

        if (isStyle14) {
            return (
                <>
                    <OverlayContainerWithLinkAndText
                        overlayNumber={1}
                        hasImage={hasOverlayImage}
                        imageSrc={selectedOverlayImage}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 1)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[1]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                        hasText={!!overlayTexts[1]}
                        onTextClick={(e) => handleTextButtonClick(e, 1)}
                        textContent={overlayTexts[1]}
                        showText={showTextForThisTemplate}
                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={2}
                        hasImage={hasOverlayImage2}
                        imageSrc={selectedOverlayImage2}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 2)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[2]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 2)}
                        hasText={!!overlayTexts[2]}
                        onTextClick={(e) => handleTextButtonClick(e, 2)}
                        textContent={overlayTexts[2]}
                        showText={showTextForThisTemplate}
                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={3}
                        hasImage={hasOverlayImage3}
                        imageSrc={selectedOverlayImage3}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 3)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[3]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 3)}
                        hasText={!!overlayTexts[3]}
                        onTextClick={(e) => handleTextButtonClick(e, 3)}
                        textContent={overlayTexts[3]}
                        showText={showTextForThisTemplate}
                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={4}
                        hasImage={hasOverlayImage4}
                        imageSrc={selectedOverlayImage4}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 4)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[4]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 4)}
                        hasText={!!overlayTexts[4]}
                        onTextClick={(e) => handleTextButtonClick(e, 4)}
                        textContent={overlayTexts[4]}
                        showText={showTextForThisTemplate}
                    />
                </>
            );
        }

        if (hasFourOverlays && !isStyle14) {
            return (
                <>
                    {/* First overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={1}
                        hasImage={hasOverlayImage}
                        imageSrc={selectedOverlayImage}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 1)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[1]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                        hasText={!!overlayTexts[1]}
                        onTextClick={(e) => handleTextButtonClick(e, 1)}
                        textContent={overlayTexts[1]}
                        showText={showTextForThisTemplate}
                    />
                    {/* Second overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={2}
                        hasImage={hasOverlayImage2}
                        imageSrc={selectedOverlayImage2}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 2)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[2]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 2)}
                        hasText={!!overlayTexts[2]}
                        onTextClick={(e) => handleTextButtonClick(e, 2)}
                        textContent={overlayTexts[2]}
                        showText={showTextForThisTemplate}
                    />
                    {/* Third overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={3}
                        hasImage={hasOverlayImage3}
                        imageSrc={selectedOverlayImage3}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 3)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[3]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 3)}
                        hasText={!!overlayTexts[3]}
                        onTextClick={(e) => handleTextButtonClick(e, 3)}
                        textContent={overlayTexts[3]}
                        showText={showTextForThisTemplate}
                    />

                    {/* Fourth overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={4}
                        hasImage={hasOverlayImage4}
                        imageSrc={selectedOverlayImage4}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={(e) => handleOverlayClick(e, 4)}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[4]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 4)}
                        hasText={!!overlayTexts[4]}
                        onTextClick={(e) => handleTextButtonClick(e, 4)}
                        textContent={overlayTexts[4]}
                        showText={showTextForThisTemplate}
                    />
                </>
            );
        }

        if (hasFiveOverlays || hasSixOverlays) {
            const overlayCount = hasFiveOverlays ? 5 : 6;
            return (
                <>
                    {Array.from({ length: overlayCount }, (_, i) => i + 1).map((overlayNumber) => {
                        const hasImage =
                            (overlayNumber === 1 && hasOverlayImage) ||
                            (overlayNumber === 2 && hasOverlayImage2) ||
                            (overlayNumber === 3 && hasOverlayImage3) ||
                            (overlayNumber === 4 && hasOverlayImage4) ||
                            (overlayNumber === 5 && hasOverlayImage5) ||
                            (overlayNumber === 6 && hasOverlayImage6);

                        const imageSrc =
                            (overlayNumber === 1 && selectedOverlayImage) ||
                            (overlayNumber === 2 && selectedOverlayImage2) ||
                            (overlayNumber === 3 && selectedOverlayImage3) ||
                            (overlayNumber === 4 && selectedOverlayImage4) ||
                            (overlayNumber === 5 && selectedOverlayImage5) ||
                            (overlayNumber === 6 && selectedOverlayImage6);

                        return (
                            <OverlayContainerWithLinkAndText
                                key={overlayNumber}
                                overlayNumber={overlayNumber}
                                hasImage={hasImage}
                                imageSrc={imageSrc}
                                placeholderUrl={getOverlayPlaceholderUrl(overlayNumber)}
                                onClick={(e) => handleOverlayClick(e, overlayNumber)}
                                title={`Click to upload overlay ${overlayNumber} image`}
                                hasLink={!!overlayLinks[overlayNumber]}
                                onLinkClick={(e) => handleLinkButtonClick(e, overlayNumber)}
                                hasText={!!overlayTexts[overlayNumber]}
                                onTextClick={(e) => handleTextButtonClick(e, overlayNumber)}
                                textContent={overlayTexts[overlayNumber]}
                                showText={showTextForThisTemplate}
                            />
                        );
                    })}
                </>
            );
        }

        if (hasFourOverlays) {
            return (
                <>
                    {/* First overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={1}
                        hasImage={hasOverlayImage}
                        imageSrc={selectedOverlayImage}
                        placeholderUrl={getOverlayPlaceholderUrl()}
                        onClick={handleOverlayClick}
                        title="Click to upload overlay image"
                        hasLink={!!overlayLinks[1]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                        hasText={!!overlayTexts[1]}
                        onTextClick={(e) => handleTextButtonClick(e, 1)}
                        textContent={overlayTexts[1]}
                        showText={showTextForThisTemplate}

                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={2}
                        hasImage={hasOverlayImage2}
                        imageSrc={selectedOverlayImage2}
                        placeholderUrl={getOverlayPlaceholderUrl(2)}
                        onClick={(e) => handleOverlayClick(e, 2)}
                        title="Click to upload second overlay image"
                        hasLink={!!overlayLinks[2]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 2)}
                        hasText={!!overlayTexts[2]}
                        onTextClick={(e) => handleTextButtonClick(e, 2)}
                        textContent={overlayTexts[2]}
                        showText={showTextForThisTemplate}
                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={3}
                        hasImage={hasOverlayImage3}
                        imageSrc={selectedOverlayImage3}
                        placeholderUrl={getOverlayPlaceholderUrl(3)}
                        onClick={(e) => handleOverlayClick(e, 3)}
                        title="Click to upload third overlay image"
                        hasLink={!!overlayLinks[3]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 3)}
                        hasText={!!overlayTexts[3]}
                        onTextClick={(e) => handleTextButtonClick(e, 3)}
                        textContent={overlayTexts[3]}
                        showText={showTextForThisTemplate}
                    />

                    <OverlayContainerWithLinkAndText
                        overlayNumber={4}
                        hasImage={hasOverlayImage4}
                        imageSrc={selectedOverlayImage4}
                        placeholderUrl={getOverlayPlaceholderUrl(4)}
                        onClick={(e) => handleOverlayClick(e, 4)}
                        title="Click to upload fourth overlay image"
                        hasLink={!!overlayLinks[4]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 4)}
                        hasText={!!overlayTexts[4]}
                        onTextClick={(e) => handleTextButtonClick(e, 4)}
                        textContent={overlayTexts[4]}
                        showText={showTextForThisTemplate}
                    />
                </>
            );
        };

        if (hasThreeOverlays) {
            return (
                <>
                    {/* First overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={1}
                        hasImage={hasOverlayImage}
                        imageSrc={selectedOverlayImage}
                        placeholderUrl={getOverlayPlaceholderUrl(1)}
                        onClick={(e) => handleOverlayClick(e, 1)}
                        title="Click to upload first overlay image"
                        hasLink={!!overlayLinks[1]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                        showText={false}
                        hasOverlayText={false}
                    />
                    {/* Second overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={2}
                        hasImage={hasOverlayImage2}
                        imageSrc={selectedOverlayImage2}
                        placeholderUrl={getOverlayPlaceholderUrl(2)}
                        onClick={(e) => handleOverlayClick(e, 2)}
                        title="Click to upload second overlay image"
                        hasLink={!!overlayLinks[2]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 2)}
                        showText={false}
                        hasOverlayText={false}
                    />
                    {/* Third overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={3}
                        hasImage={hasOverlayImage3}
                        imageSrc={selectedOverlayImage3}
                        placeholderUrl={getOverlayPlaceholderUrl(3)}
                        onClick={(e) => handleOverlayClick(e, 3)}
                        title="Click to upload third overlay image"
                        hasLink={!!overlayLinks[3]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 3)}
                        showText={false}
                        hasOverlayText={false}
                    />
                </>
            );
        };

        if (hasMultipleOverlays) {
            return (
                <>
                    {/* First overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={1}
                        hasImage={hasOverlayImage}
                        imageSrc={selectedOverlayImage}
                        placeholderUrl={getOverlayPlaceholderUrl(1)}
                        onClick={(e) => handleOverlayClick(e, 1)}
                        title="Click to upload first overlay image"
                        hasLink={!!overlayLinks[1]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                        showText={false}
                        hasOverlayText={false}

                    />
                    {/* Second overlay */}
                    <OverlayContainerWithLinkAndText
                        overlayNumber={2}
                        hasImage={hasOverlayImage2}
                        imageSrc={selectedOverlayImage2}
                        placeholderUrl={getOverlayPlaceholderUrl(2)}
                        onClick={(e) => handleOverlayClick(e, 2)}
                        title="Click to upload second overlay image"
                        hasLink={!!overlayLinks[2]}
                        onLinkClick={(e) => handleLinkButtonClick(e, 2)}
                        showText={false}
                        hasOverlayText={false}
                    />
                </>
            );
        };

        // Single overlay templates
        return (
            <OverlayContainerWithLinkAndText
                overlayNumber={1}
                hasImage={hasOverlayImage}
                imageSrc={selectedOverlayImage}
                placeholderUrl={getOverlayPlaceholderUrl()}
                onClick={handleOverlayClick}
                title="Click to upload overlay image"
                hasLink={!!overlayLinks[1]}
                onLinkClick={(e) => handleLinkButtonClick(e, 1)}
                hasText={!overlayTexts[1]}
                textContent={overlayTexts[1]}
                showText={false}
                hasOverlayText={false}
            />
        );
    };

    const renderLinkManagementSection = () => {
        const overlaysWithLinks = Object.keys(overlayLinks)
            .map(num => parseInt(num))
            .filter(num => overlayLinks[num])
            .sort((a, b) => a - b);

        if (overlaysWithLinks.length === 0) return null;

        return (
            <div style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Overlay Links</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '5px' }}>
                    {overlaysWithLinks.map(overlayNumber => (
                        <div key={overlayNumber} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '5px',
                            backgroundColor: 'white',
                            borderRadius: '3px',
                            fontSize: '12px'
                        }}>
                            <span>Overlay {overlayNumber}:</span>
                            <a
                                href={overlayLinks[overlayNumber]}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    margin: '0 5px',
                                    color: '#007BFF',
                                    textDecoration: 'none',
                                    maxWidth: '150px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                                title={overlayLinks[overlayNumber]}
                            >
                                {overlayLinks[overlayNumber]}
                            </a>
                            <button
                                style={{
                                    ...linkButtonStyles,
                                    backgroundColor: '#dc3545',
                                    padding: '2px 6px',
                                    fontSize: '10px'
                                }}
                                onClick={() => handleRemoveLink(overlayNumber)}
                                title="Remove link"
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderTextManagementSection = () => {

        const templatesWithTextManagement = [
            'style_12', 'style_13', 'style_14', 'style_15',
            'style_16', 'style_17', 'style_18', 'style_19', 'style_20'
        ];

        if (!templatesWithTextManagement.includes(selectedTemplate)) {
            return null;
        }

        const overlaysWithText = Object.keys(overlayTexts)
            .map(num => parseInt(num))
            .filter(num => overlayTexts[num] && overlayTexts[num].trim())
            .sort((a, b) => a - b);

        if (overlaysWithText.length === 0) return null;

        return (
            <div style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f0f8ff', borderRadius: '5px' }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Overlay Texts</h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '5px' }}>
                    {overlaysWithText.map(overlayNumber => (
                        <div key={overlayNumber} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '5px',
                            backgroundColor: 'white',
                            borderRadius: '3px',
                            fontSize: '12px'
                        }}>
                            <span>Overlay {overlayNumber}:</span>
                            <span style={{
                                margin: '0 5px',
                                maxWidth: '150px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                                title={overlayTexts[overlayNumber]}
                            >
                                {overlayTexts[overlayNumber]}
                            </span>
                            <button
                                style={{
                                    ...linkButtonStyles,
                                    backgroundColor: '#17a2b8',
                                    padding: '2px 6px',
                                    fontSize: '10px'
                                }}
                                onClick={() => handleTextButtonClick({ stopPropagation: () => { } }, overlayNumber)}
                                title="Edit text"
                            >
                                ✏️
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const handleSubmitTemplate = () => {
        const config = {
            backgroundImage: selectedImage ? fileInputRef.current?.files[0] : null,
            backgroundVideo: selectedVideo ? videoInputRef.current?.files[0] : null,
            overlayImages: {
                1: selectedOverlayImage ? overlayInputRef.current?.files[0] : null,
                2: selectedOverlayImage2 ? overlayInputRef2.current?.files[0] : null,
                3: selectedOverlayImage3 ? overlayInputRef3.current?.files[0] : null,
                4: selectedOverlayImage4 ? overlayInputRef4.current?.files[0] : null,
                5: selectedOverlayImage5 ? overlayInputRef5.current?.files[0] : null,
                6: selectedOverlayImage6 ? overlayInputRef6.current?.files[0] : null,
            },
            overlayLinks: overlayLinks,
            overlayTexts: overlayTexts
        };

        if (onTemplateConfig) {
            onTemplateConfig(config);
        } else {
            onClose();
        }
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <h2 style={{ color: 'red', marginBottom: '20px' }}>Choose Template</h2>

                <select value={selectedTemplate} onChange={(e) => onTemplateSelect(e.target.value)} style={selectStyles}>
                    {templateOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>

                <input type="file" ref={fileInputRef} onChange={handleFileSelect} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={videoInputRef} onChange={handleVideoSelect} accept="video/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef} onChange={(e) => handleOverlayImageSelect(e, 1)} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef2} onChange={(e) => handleOverlayImageSelect(e, 2)} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef3} onChange={(e) => handleOverlayImageSelect(e, 3)} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef4} onChange={(e) => handleOverlayImageSelect(e, 4)} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef5} onChange={(e) => handleOverlayImageSelect(e, 5)} accept="image/*" style={{ display: 'none' }} />
                <input type="file" ref={overlayInputRef6} onChange={(e) => handleOverlayImageSelect(e, 6)} accept="image/*" style={{ display: 'none' }} />

                <div style={phoneContainerStyles}>
                    <div style={phoneScreenStyles}>
                        <div
                            style={backgroundPlaceholderStyles}
                            onClick={handleBackgroundClick}
                            title={isStyle2 ? "Click to upload background image or video" : "Click to upload background image"}>
                            {hasBackgroundMedia ? (
                                <>
                                    {selectedImage && <img src={selectedImage} alt="Background" style={placeholderImageStyles} />}
                                    {selectedVideo && <video src={selectedVideo} style={videoStyles} autoPlay muted loop playsInline />}
                                </>
                            ) : (
                                <img src={placeholderUrl} alt="Background placeholder" style={placeholderImageStyles} />
                            )}
                        </div>

                        {renderOverlayContainers()}

                        {(hasBackgroundMedia || hasOverlaySupport) && (
                            <>
                                <button style={skipButtonStyles}>Skip Ad</button>
                                <button style={buyNowButtonStyles}>Buy</button>
                            </>
                        )}
                    </div>
                </div>

                {renderLinkManagementSection()}

                {renderTextManagementSection()}

                <div style={{ marginBottom: '10px' }}>
                    {!hasBackgroundMedia && (
                        <>
                            <button style={uploadButtonStyles} onClick={isStyle2 ? handleUploadImage : handleBackgroundClick}>
                                Upload Background {isStyle2 ? 'Image' : ''}
                            </button>
                            {isStyle2 && (
                                <button style={{ ...uploadButtonStyles, backgroundColor: '#17a2b8' }} onClick={handleUploadVideo}>
                                    Upload Background Video
                                </button>
                            )}
                        </>
                    )}

                    {hasOverlaySupport && (
                        <>
                            {(!hasOverlayImage && !hasMultipleOverlays) && (
                                <button style={getOverlayUploadButtonStyle()} onClick={() => handleUploadOverlay(1)}>
                                    Upload Overlay Image
                                </button>
                            )}
                            {hasMultipleOverlays && (
                                <>
                                    {!hasOverlayImage && (
                                        <button style={getOverlayUploadButtonStyle(1)} onClick={() => handleUploadOverlay(1)}>
                                            Upload First Overlay
                                        </button>
                                    )}
                                    {!hasOverlayImage2 && (
                                        <button style={getOverlayUploadButtonStyle(2)} onClick={() => handleUploadOverlay(2)}>
                                            Upload Second Overlay
                                        </button>
                                    )}
                                    {hasThreeOverlays && !hasOverlayImage3 && (
                                        <button style={getOverlayUploadButtonStyle(3)} onClick={() => handleUploadOverlay(3)}>
                                            Upload Third Overlay
                                        </button>
                                    )}
                                    {hasFourOverlays && !hasOverlayImage4 && (
                                        <button style={getOverlayUploadButtonStyle(4)} onClick={() => handleUploadOverlay(4)}>
                                            Upload Fourth Overlay
                                        </button>
                                    )}
                                    {hasFiveOverlays && !hasOverlayImage5 && (
                                        <button style={getOverlayUploadButtonStyle(5)} onClick={() => handleUploadOverlay(5)}>
                                            Upload Fifth Overlay
                                        </button>
                                    )}
                                    {hasSixOverlays && !hasOverlayImage6 && (
                                        <button style={getOverlayUploadButtonStyle(6)} onClick={() => handleUploadOverlay(6)}>
                                            Upload Sixth Overlay
                                        </button>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>

                <div style={{ marginBottom: '10px' }}>
                    {hasBackgroundMedia && (
                        <button style={removeButtonStyles} onClick={handleRemoveBackground}>
                            Remove Background
                        </button>
                    )}
                    {hasOverlaySupport && hasOverlayImage && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle().backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(1)}>
                            Remove {hasMultipleOverlays ? 'First ' : ''}Overlay
                        </button>
                    )}
                    {hasMultipleOverlays && hasOverlayImage2 && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle(2).backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(2)}>
                            Remove Second Overlay
                        </button>
                    )}
                    {hasThreeOverlays && hasOverlayImage3 && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle(3).backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(3)}>
                            Remove Third Overlay
                        </button>
                    )}
                    {hasFourOverlays && hasOverlayImage4 && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle(4).backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(4)}>
                            Remove Fourth Overlay
                        </button>
                    )}
                    {hasFiveOverlays && hasOverlayImage5 && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle(5).backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(5)}>
                            Remove Fifth Overlay
                        </button>
                    )}
                    {hasSixOverlays && hasOverlayImage6 && (
                        <button style={{ ...removeButtonStyles, backgroundColor: getOverlayUploadButtonStyle(6).backgroundColor, marginLeft: '10px' }}
                            onClick={() => handleRemoveOverlay(6)}>
                            Remove Sixth Overlay
                        </button>
                    )}
                </div>

                {editingLink && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000
                    }}>
                        <div style={linkModalStyles}>
                            <h3>Add/Edit Link for Overlay {editingLink}</h3>
                            <input
                                type="url"
                                value={linkInputValue}
                                onChange={(e) => setLinkInputValue(e.target.value)}
                                placeholder="https://example.com"
                                style={linkInputStyles}
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '15px' }}>
                                <button
                                    style={{ ...linkButtonStyles, backgroundColor: '#6c757d' }}
                                    onClick={handleCancelEdit}>
                                    Cancel
                                </button>
                                {overlayLinks[editingLink] && (
                                    <button
                                        style={{ ...linkButtonStyles, backgroundColor: '#dc3545' }}
                                        onClick={() => handleRemoveLink(editingLink)}
                                    >
                                        Remove Link
                                    </button>
                                )}
                                <button
                                    style={{ ...linkButtonStyles, backgroundColor: '#28a745' }}
                                    onClick={handleSaveLink}
                                    disabled={!linkInputValue.trim()}
                                >
                                    Save Link
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {editingText && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000
                    }}>
                        <div style={textModalStyles}>
                            <h3>Edit Text for Overlay {editingText}</h3>
                            <textarea
                                value={textInputValue}
                                onChange={(e) => setTextInputValue(e.target.value)}
                                placeholder="Enter text for this overlay..."
                                style={textInputStyles}
                                rows="4"
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '15px' }}>
                                <button
                                    style={{ ...linkButtonStyles, backgroundColor: '#6c757d' }}
                                    onClick={handleCancelTextEdit}>
                                    Cancel
                                </button>
                                <button
                                    style={{ ...linkButtonStyles, backgroundColor: '#28a745' }}
                                    onClick={handleSaveText}
                                    disabled={!textInputValue.trim()}
                                >
                                    Save Text
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ marginBottom: '20px', fontSize: '14px', color: '#666' }}>
                    <strong>Selected Template:</strong> {templateOptions.find(opt => opt.value === selectedTemplate)?.label}
                    {isStyle2 && <div style={{ fontSize: '12px', color: '#28a745', marginTop: '5px' }}>✓ Supports background video</div>}
                    {isStyle3 && <div style={{ fontSize: '12px', color: '#dc3545', marginTop: '5px' }}>✓ Rectangular overlay (200×120)</div>}
                    {isStyle4 && <div style={{ fontSize: '12px', color: '#6610f2', marginTop: '5px' }}>✓ Square overlay (150×150)</div>}
                    {isStyle5 && <div style={{ fontSize: '12px', color: '#20c997', marginTop: '5px' }}>✓ Tall overlay (200×400)</div>}
                    {isStyle6 && <div style={{ fontSize: '12px', color: '#fd7e14', marginTop: '5px' }}>✓ Two vertical overlays (200×200)</div>}
                    {isStyle7 && <div style={{ fontSize: '12px', color: '#e83e8c', marginTop: '5px' }}>✓ Two horizontal overlays (130×220)</div>}
                    {isStyle8 && <div style={{ fontSize: '12px', color: '#4e0628ff', marginTop: '5px' }}>✓ Two horizontal overlays (130×250)</div>}
                    {isStyle9 && <div style={{ fontSize: '12px', color: '#17a2b8', marginTop: '5px' }}>✓ Three overlays (2 top + 1 bottom)</div>}
                    {isStyle10 && <div style={{ fontSize: '12px', color: '#343a40', marginTop: '5px' }}>✓ Three overlays (2 top + 1 bottom)</div>}
                    {isStyle11 && <div style={{ fontSize: '12px', color: '#6f42c1', marginTop: '5px' }}>✓ Column layout (2 left + 1 right)</div>}
                    {isStyle12 && <div style={{ fontSize: '12px', color: '#ff6b6b', marginTop: '5px' }}>✓ Column layout (3 left + 1 right) + Text in each overlay</div>}
                    {isStyle13 && <div style={{ fontSize: '12px', color: '#ff6b6b', marginTop: '5px' }}>✓ Column layout (3 left + 1 right) + Text in each overlay</div>}
                    {isStyle14 && <div style={{ fontSize: '12px', color: '#6f42c1', marginTop: '5px' }}>✓ Two columns (2 overlays each) with separate text containers</div>}
                    {isStyle15 && <div style={{ fontSize: '12px', color: '#ffc107', marginTop: '5px' }}>✓ Two columns (2 overlays each: 130×130 in col1, 130×200 in col2) with separate text containers</div>}
                    {isStyle16 && <div style={{ fontSize: '12px', color: '#dc3545', marginTop: '5px' }}>✓ 5 overlays: Col1 (130×200, 130×100), Col2 (130×120, 130×180), Bottom (200×130)</div>}
                    {isStyle17 && <div style={{ fontSize: '12px', color: '#20c997', marginTop: '5px' }}>✓ 5 overlays in 5 columns (80×250 each)</div>}
                    {isStyle18 && <div style={{ fontSize: '12px', color: '#6f42c1', marginTop: '5px' }}>✓ 6 circular overlays (130×130) in 2 columns (3 each)</div>}
                    {isStyle19 && <div style={{ fontSize: '12px', color: '#fd7e14', marginTop: '5px' }}>✓ 6 overlays: Col1 (130×120, 130×120, 130×100), Col2 (130×120, 130×220), Bottom (250×120)</div>}
                    {isStyle20 && <div style={{ fontSize: '12px', color: '#17a2b8', marginTop: '5px' }}>✓ 6 overlays: Col1 (130×140, 130×80, 130×140), Col2 (130×120, 130×80, 130×150)</div>}
                    <div style={{ fontSize: '12px', color: '#28a745', marginTop: '5px' }}>
                        💡 <strong>Tip:</strong> Click the link icon (🔗) on overlay images to add/edit links
                    </div>
                </div>

                <button style={buttonStyles} onClick={handleSubmitTemplate}>Select Template</button>
            </div>
        </div>
    );
};

const ProfileAddranked = ({ onClose, onRanked, loading }) => {
    const [rank, setRank] = useState('');
    const [username, setUsername] = useState('');
    const [addlink, setAddlink] = useState('');
    const [linktext, setLinktext] = useState('');
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [days, setDays] = useState(0);
    const [pairs, setPairs] = useState([{ link: '', image: '' }]);
    const MAX_PAIRS = 5;

    const addPair = () => {
        if (pairs.length < MAX_PAIRS) {
            setPairs([...pairs, { link: '', image: '' }]);
        } else {
            alert(`You can only add up to ${MAX_PAIRS} pairs.`);
        }
    };

    const removePair = (index) => {
        setPairs(pairs.filter((_, i) => i !== index));
    };

    const handlePairChange = (index, field, value) => {
        const updatedPairs = pairs.map((pair, i) =>
            i === index ? { ...pair, [field]: value } : pair
        );
        setPairs(updatedPairs);

        if (field === 'image' && value) {
            const reader = new FileReader();
            reader.onload = () => {
                updatedPairs[index] = { ...updatedPairs[index], preview: reader.result };
                setPairs([...updatedPairs]);
            };
            reader.readAsDataURL(value);
        }
    };

    const handleAddranked = () => {
        // Calculate total time in seconds
        let totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

        // Validate required fields
        if (!rank || rank <= 0) {
            alert('Rank is required and must be greater than 0.');
            return;
        }

        if (!username) {
            alert('Username is required.');
            return;
        }

        if (totalSeconds <= 0) {
            alert('Please select a valid time duration.');
            return;
        }

        if (window.confirm(`Are you sure you want to add this as a Ranked Video?`)) {
            const links = pairs.map((pair) => pair.link);
            const images = pairs.map((pair) => pair.image);

            onRanked(totalSeconds, rank, links, images, addlink, linktext, username);
        }
    };

    const modalStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: '1000',
    };

    const modalContentStyles = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        width: '600px',
        height: '600px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        overflowY: 'auto',
    };

    const inputContainerStyles = {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
    };

    const inputStyles = {
        width: 'calc(50% - 10px)',
        padding: '10px',
        margin: '0 5px',
        borderRadius: '5px',
        border: '1px solid #ccc',
    };

    const buttonStyles = {
        backgroundColor: '#007BFF',
        color: 'white',
        padding: '10px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const buttonAddStyles = {
        backgroundColor: pairs.length >= MAX_PAIRS ? '#6c757d' : 'green',
        color: 'white',
        padding: '10px 20px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const buttonCancelStyles = {
        backgroundColor: '#6c757d',
        color: 'white',
        padding: '10px 20px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const previewStyles = {
        width: '100px',
        height: '100px',
        objectFit: 'cover',
        borderRadius: '5px',
        marginLeft: '10px',
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <h2 style={{ color: 'red', marginBottom: '20px' }}>Add Video Ranked Request For Profile</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"></div>
                    </div>
                )}
                <p style={{ marginBottom: '20px' }}>Select the time for Ranked</p>
                <TimePicker label="Days" value={days} onChange={setDays} />
                <TimePicker label="Hours" value={hours} onChange={setHours} />
                <TimePicker label="Minutes" value={minutes} onChange={setMinutes} />
                <TimePicker label="Seconds" value={seconds} onChange={setSeconds} />
                <input
                    type="text"
                    value={addlink}
                    onChange={(e) => setAddlink(e.target.value)}
                    placeholder="addlink"
                    style={{ ...inputStyles, margin: '0 0 10px 0' }}
                />
                <input
                    type="text"
                    value={linktext}
                    onChange={(e) => setLinktext(e.target.value)}
                    placeholder="linktext"
                    maxLength={15}
                    style={{ ...inputStyles, margin: '0 0 10px 0' }}
                />
                <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Username"
                    required
                    style={{ ...inputStyles, margin: '0 0 10px 0' }}
                />
                <input
                    type="number"
                    value={rank}
                    onChange={(e) => setRank(e.target.value)}
                    placeholder="Rank"
                    min="1"
                    required
                    style={{ ...inputStyles, margin: '0 0 10px 0' }}
                />
                {pairs.map((pair, index) => (
                    <div key={index} style={inputContainerStyles}>
                        <input
                            type="text"
                            value={pair.link}
                            onChange={(e) => handlePairChange(index, 'link', e.target.value)}
                            placeholder="Add Link"
                            style={inputStyles}
                        />
                        <input
                            type="file"
                            onChange={(e) => handlePairChange(index, 'image', e.target.files[0])}
                            style={inputStyles}
                        />
                        {pair.preview && <img src={pair.preview} alt="Preview" style={previewStyles} />}
                        <button
                            onClick={() => removePair(index)}
                            style={{ ...buttonStyles, backgroundColor: '#dc3545', marginLeft: '10px' }}
                        >
                            Remove
                        </button>
                    </div>
                ))}
                <button
                    onClick={addPair}
                    style={buttonAddStyles}
                    disabled={pairs.length >= MAX_PAIRS}
                >
                    Add More
                </button>
                <button
                    style={buttonStyles}
                    onClick={handleAddranked}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#007BFF')}
                >
                    Add Ranked
                </button>
                <button
                    style={buttonCancelStyles}
                    onClick={onClose}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

const OpenCommeentModel = ({
    onClose,
    loading,
    commentdata,
    HandleComment,
    setIsEditModalOpen,
    isEditModalOpen,
    HandleCommentDelet,
    isEditReplyCommentModalOpen,
    setisEditReplyCommentModalOpen,
    HandleReplyComment,
    HandleCommentReplyDelete,
    hasSubFeatureEditvideocommet,
    hasSubFeatureDeletevideocommet
}) => {
    const [expandedReplies, setExpandedReplies] = useState({});
    const [editedText, setEditedText] = useState('');
    const [commentId, setCommentId] = useState(null);
    const [searchTerm, setSearchTerm] = useState(''); // State for search term
    const [currentPage, setCurrentPage] = useState(1);
    const commentsPerPage = 5; // Set comments per page
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const startDateObj = startDate ? new Date(startDate) : null;
    const endDateObj = endDate ? new Date(endDate) : null;
    const [pageRange, setPageRange] = useState([1, 2, 3, 4]); // Visible page range

    const toggleReplies = (commentId) => {
        setExpandedReplies((prev) => ({
            ...prev,
            [commentId]: !prev[commentId],
        }));
    };
    console.log(commentdata, 'commentdatacommentdata')
    const openEditModel = (id, commentData) => {
        setCommentId(id);
        setEditedText(commentData);
        setIsEditModalOpen(true);
    };

    const HandleEditComment = () => {
        const payload = {
            id: commentId,
            commentdata: editedText,
        };
        HandleComment(payload);
    };

    const openReplyEditModel = (id, commentData) => {
        setCommentId(id);
        setEditedText(commentData);
        setisEditReplyCommentModalOpen(true);
    };

    const ReplyComment = () => {
        const payload = {
            id: commentId,
            commentdata: editedText,
        };
        HandleReplyComment(payload);
    };

    const HandleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this comment?")) {
            HandleCommentDelet(id);
        }
        // HandleCommentDelet(id);
    };

    const HandleClean = () => {
        setEditedText('');
    };

    const HandleReplyDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this comment?")) {
            HandleCommentReplyDelete(id);
        }
        // HandleCommentReplyDelete(id);
    };


    const filteredComments = Array.isArray(commentdata?.comments)
        ? commentdata.comments.filter((comment) => {
            // Match the search term for comment or replies
            const commentMatches =
                comment.user?.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
                comment.comment_data.toLowerCase().includes(searchTerm.toLowerCase());

            const replyMatches = comment.replies?.some((reply) =>
                reply.user?.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
                reply.reply_message.toLowerCase().includes(searchTerm.toLowerCase())
            );

            // Convert comment's createdAt to a Date object
            const commentDate = new Date(comment.createdAt).getTime(); // Get timestamp in UTC

            // Debugging to see the comment date
            console.log(commentDate, 'commentDate');

            const isWithinDateRange = (
                (!startDateObj || new Date(commentDate).setHours(0, 0, 0, 0) >= new Date(startDateObj).setHours(0, 0, 0, 0)) &&
                (!endDateObj || new Date(commentDate).setHours(0, 0, 0, 0) <= new Date(endDateObj).setHours(0, 0, 0, 0))
            );

            // Return true if either the search term matches or the comment is within the date range
            return (commentMatches || replyMatches) && isWithinDateRange;
        })
        : [];


    // Pagination logic
    const totalPages = Math.ceil(filteredComments.length / commentsPerPage);
    const currentComments = filteredComments.slice(
        (currentPage - 1) * commentsPerPage,
        currentPage * commentsPerPage
    );

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    // const goToNextPage = () => {
    //   if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    // };

    // const goToPreviousPage = () => {
    //   if (currentPage > 1) setCurrentPage(currentPage - 1);
    // };

    const handleDateChange = (date, type) => {
        if (type === 'start') {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
    };

    const handleClean = () => {
        setStartDate(null)
        setEndDate(null)
    }


    // Dynamically update the initial page range based on totalPages
    useEffect(() => {
        const initialRange = [];
        const rangeSize = 4;
        const totalVisiblePages = Math.min(rangeSize, totalPages);

        for (let i = 1; i <= totalVisiblePages; i++) {
            initialRange.push(i);
        }
        setPageRange(initialRange);
    }, [totalPages]);

    const updatePageRange = (startPage) => {
        const rangeSize = 4; // Number of pages visible at a time
        const newRange = [];

        for (
            let i = startPage;
            i < startPage + rangeSize && i <= totalPages;
            i++
        ) {
            newRange.push(i);
        }

        setPageRange(newRange);
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);

        // If the clicked page is the last in the current range, load the next range
        if (page === pageRange[pageRange.length - 1] && page < totalPages) {
            updatePageRange(page);
        }

        // If the clicked page is the first in the current range and not the first page
        if (page === pageRange[0] && page > 1) {
            updatePageRange(page - 3);
        }
    };

    const handleFirst = () => {
        setCurrentPage(1);
        updatePageRange(1);
    };

    const handleLast = () => {
        setCurrentPage(totalPages);
        const lastRangeStart = Math.max(
            1,
            Math.floor((totalPages - 1) / 4) * 4 + 1
        );
        updatePageRange(lastRangeStart);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            // Check if we are at the start of the current visible range
            if (currentPage === pageRange[0]) {
                // If we are at the first page of the range, move to the previous set of pages
                const previousRangeStart = Math.max(pageRange[0] - 4, 1); // Ensure start page is >= 1
                updatePageRange(previousRangeStart);
            } else {
                setCurrentPage(currentPage - 1);
            }
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            // If we are at the end of the current visible range, load the next range
            if (currentPage === pageRange[pageRange.length - 1] && currentPage < totalPages) {
                updatePageRange(pageRange[pageRange.length - 1]);
            } else {
                setCurrentPage(currentPage + 1);
            }
        }
    };

    const modalStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: '1000',
    };

    const modalContentStyles = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '10px',
        width: '700px',
        height: '80vh',
        maxHeight: '80vh',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        position: 'relative',
    };

    const headerStyles = {
        color: 'red',
        marginBottom: '20px',
        textAlign: 'center',
        position: 'sticky',
        top: '0',
        backgroundColor: '#fff',
        padding: '10px 0',
        zIndex: '1',
    };

    const scrollableContentStyles = {
        maxHeight: 'calc(32vh - 7px)',
        overflowY: 'auto',
    };

    const tableStyles = {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '20px',
    };

    const thStyles = {
        borderBottom: '1px solid #ddd',
        padding: '10px',
        fontWeight: 'bold',
        backgroundColor: '#f7f7f7',
        textAlign: 'left',
    };

    const tdStyles = {
        padding: '10px',
        borderBottom: '1px solid #ddd',
        textAlign: 'left',
    };

    const buttonStyles = {
        backgroundColor: '#007BFF',
        color: 'white',
        padding: '5px 10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        margin: '2px',
    };

    const buttonStylesReply = {
        backgroundColor: 'red',
        color: 'white',
        padding: '5px 10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '14px',
        margin: '2px',
    };

    const buttonCancelStyles = {
        backgroundColor: '#6c757d',
        color: 'white',
        padding: '10px 20px',
        margin: '10px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    };

    const replyStyles = {
        backgroundColor: '#f1f1f1',
        paddingLeft: '40px',
        color: '#c0392b',
        fontStyle: 'italic',
    };
    const handleNoAccess = () => {
        alert('You are not able to access this feature.');
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <h2 style={headerStyles}>Comment Data</h2>

                {/* Search input for filtering comments */}
                <input
                    type="text"
                    placeholder="Search by username"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{
                        width: '100%',
                        padding: '10px',
                        marginBottom: '20px',
                        borderRadius: '5px',
                        border: '1px solid #ddd',
                    }}
                />
                {/* Date Pickers for Start and End Date */}
                <div style={{ marginBottom: '20px' }}>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => handleDateChange(date, 'start')}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="Start Date"
                        maxDate={new Date()} // Ensure start date is not in the future
                        dateFormat="dd:MM:yyyy"
                        style={{
                            padding: '5px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                        }}
                    />
                    <span style={{ margin: '0 10px' }}>to</span>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => handleDateChange(date, 'end')}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="End Date"
                        minDate={startDate} // Ensure end date is not before start date
                        maxDate={new Date()} // Disable selecting future dates
                        dateFormat="dd:MM:yyyy"
                        style={{
                            padding: '5px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                        }}
                    />

                    <button
                        style={buttonStyles}
                        onClick={handleClean}
                    >
                        Clean
                    </button>
                </div>

                <div style={scrollableContentStyles}>
                    <table style={tableStyles}>
                        <thead>
                            <tr>
                                <th style={thStyles}>ID</th>
                                <th style={thStyles}>Comment</th>
                                <th style={thStyles}>Date</th>
                                <th style={thStyles}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentComments.map((comment) => (
                                <React.Fragment key={comment.id}>
                                    <tr>
                                        <td style={tdStyles}>{comment.id}</td>
                                        <td style={tdStyles}>
                                            <strong>{comment.user?.username}</strong>: {comment.comment_data}
                                        </td>
                                        <td style={tdStyles}>
                                            {new Date(comment.createdAt).toLocaleString()} {/* Format the date to the local string */}
                                        </td>
                                        <td style={tdStyles}>
                                            <button
                                                // style={buttonStyles}
                                                onClick={() => {
                                                    if (hasSubFeatureEditvideocommet) {
                                                        openEditModel(comment.id, comment.comment_data)
                                                    } else {
                                                        handleNoAccess()
                                                    }
                                                }}
                                                style={{
                                                    ...buttonStyles,
                                                    backgroundColor:
                                                        !hasSubFeatureEditvideocommet
                                                            ? '#C5C6C7'
                                                            : '', // Set red background when there is access
                                                    cursor: !hasSubFeatureEditvideocommet ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                                }}
                                            >
                                                Edit
                                            </button>
                                            <button onClick={() => {
                                                if (hasSubFeatureDeletevideocommet) {
                                                    HandleDelete(comment.id)
                                                } else {
                                                    handleNoAccess()
                                                }
                                            }}
                                                style={{
                                                    ...buttonStyles,
                                                    backgroundColor:
                                                        !hasSubFeatureDeletevideocommet
                                                            ? '#C5C6C7'
                                                            : '', // Set red background when there is access
                                                    cursor: !hasSubFeatureDeletevideocommet ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>

                                    {comment.replies &&
                                        comment.replies
                                            .slice(0, expandedReplies[comment.id] ? comment.replies.length : 3)
                                            .map((reply) => (
                                                <tr key={reply.id}>
                                                    <td style={{ ...tdStyles, paddingLeft: '30px', color: 'red' }}></td>
                                                    <td style={{
                                                        ...tdStyles, ...replyStyles,

                                                    }} >
                                                        <strong>{reply.user?.username}</strong> replied: {reply.reply_message}
                                                    </td>

                                                    <td style={tdStyles}>
                                                        {new Date(reply.createdAt).toLocaleString()} {/* Format the date to the local string */}
                                                    </td>

                                                    <td style={tdStyles}>
                                                        <button
                                                            onClick={() => {
                                                                if (hasSubFeatureEditvideocommet) {
                                                                    openReplyEditModel(reply.id, reply.reply_message)
                                                                } else {
                                                                    handleNoAccess()
                                                                }
                                                            }}
                                                            style={{
                                                                ...buttonStylesReply,
                                                                backgroundColor:
                                                                    !hasSubFeatureEditvideocommet
                                                                        ? '#C5C6C7'
                                                                        : '', // Set red background when there is access
                                                                cursor: !hasSubFeatureEditvideocommet ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button onClick={() => {
                                                            if (hasSubFeatureDeletevideocommet) {
                                                                HandleReplyDelete(reply.id)
                                                            } else {
                                                                handleNoAccess()
                                                            }
                                                        }}
                                                            style={{
                                                                ...buttonStylesReply,
                                                                backgroundColor:
                                                                    !hasSubFeatureDeletevideocommet
                                                                        ? '#C5C6C7'
                                                                        : '', // Set red background when there is access
                                                                cursor: !hasSubFeatureDeletevideocommet ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                                            }}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}

                                    {comment.replies && comment.replies.length > 3 && (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: 'center', padding: '10px' }}>
                                                <button
                                                    style={buttonStylesReply}
                                                    onClick={() => toggleReplies(comment.id)}
                                                >
                                                    {expandedReplies[comment.id] ? 'Show Less' : 'Show More'}
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <button onClick={handleFirst} disabled={currentPage === 1}>
                        First
                    </button>
                    <button onClick={handlePrevious} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {pageRange.map((page) => (
                        <button
                            key={page}
                            onClick={() => handlePageClick(page)}
                            style={{
                                padding: "5px 10px",
                                backgroundColor: currentPage === page ? "#007bff" : "#f8f9fa",
                                color: currentPage === page ? "white" : "black",
                                border: "1px solid #ddd",
                                cursor: "pointer",
                            }}
                        >
                            {page}
                        </button>
                    ))}
                    <button onClick={handleNext} disabled={currentPage === totalPages}>
                        Next
                    </button>
                    <button onClick={handleLast} disabled={currentPage === totalPages}>
                        Last
                    </button>
                </div>


                <button style={buttonCancelStyles} onClick={onClose}>
                    Close
                </button>
            </div>

            {isEditModalOpen && (
                <div style={modalStyles}>
                    <div style={modalContentStyles}>
                        <h2>Edit Comment (ID: {commentId})</h2>

                        <textarea
                            value={editedText}
                            onChange={(e) => setEditedText(e.target.value)}
                            rows={4}
                            style={{
                                width: '100%',
                                padding: '10px',
                                marginBottom: '20px',
                                borderRadius: '5px',
                                resize: 'vertical',
                            }}
                        />

                        <div>
                            <button style={buttonStyles} onClick={HandleEditComment}>
                                Save
                            </button>
                            <button style={{ ...buttonStyles, background: 'red' }} onClick={HandleClean}>
                                Clean
                            </button>
                            <button
                                style={{ ...buttonStyles, background: 'gray' }}
                                onClick={() => setIsEditModalOpen(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isEditReplyCommentModalOpen && (
                <div style={modalStyles}>
                    <div style={modalContentStyles}>
                        <h2>Edit Comment (ID: {commentId})</h2>

                        <textarea
                            value={editedText}
                            onChange={(e) => setEditedText(e.target.value)}
                            rows={4}
                            style={{
                                width: '100%',
                                padding: '10px',
                                marginBottom: '20px',
                                borderRadius: '5px',
                                resize: 'vertical',
                            }}
                        />

                        <div>
                            <button style={buttonStyles} onClick={ReplyComment}>
                                Save
                            </button>
                            <button style={buttonStylesReply} onClick={HandleClean}>
                                Clean
                            </button>
                            <button
                                style={{ ...buttonStyles, background: 'gray' }}
                                onClick={() => setisEditReplyCommentModalOpen(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// ***********************Block Video CommentModel******************
const CustomTimePicker = ({ label, value, onChange, options }) => (
    <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
        <label style={{ fontWeight: '600', marginRight: '10px', flex: '1' }}>{label}:</label>
        <select
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            style={{
                flex: '2',
                padding: '8px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                textAlign: 'center',
                boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
        >
            {options.map((option) => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
        </select>
    </div>
);

const BlockVideoCommentModel = ({ CloseModel, FeatchUsers, searchresult, onMute }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedUsers, setSelectedUsers] = useState({});
    const [reason, setReason] = useState("");
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [days, setDays] = useState(0);
    const [openModel, setOpenModel] = useState(false);
    const [link, setLink] = useState("");
    const [image, setImage] = useState(null);
    const [video, setVideo] = useState(null);

    const dayOptions = Array.from({ length: 31 }, (_, i) => i); // 0 to 30 days
    const hourOptions = Array.from({ length: 24 }, (_, i) => i); // 0 to 23 hours
    const minuteOptions = Array.from({ length: 60 }, (_, i) => i); // 0 to 59 minutes
    const secondOptions = Array.from({ length: 60 }, (_, i) => i); // 0 to 59 seconds

    const handleSearch = () => {
        FeatchUsers(searchQuery);
        setSearchQuery("");
        setOpenModel(false)
        setReason('')
    };

    const handleSelect = (user) => {
        setSelectedUsers(user);
        setOpenModel(true);
    };

    const closeinternalModel = () => {
        setOpenModel(false)
        CloseModel()
    }

    const handleMute = () => {
        const totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;
        const mutefor = 'video'
        if (
            window.confirm(
                `Are you sure you want to Mute the Comments for ${days} days, ${hours} hours, ${minutes} minutes, and ${seconds} seconds?`
            )
        ) {
            const formData = new FormData();
            formData.append("userId", selectedUsers.id);
            formData.append("totalSeconds", totalSeconds);
            formData.append("reason", reason);
            formData.append("mutefor", mutefor)

            if (link) formData.append("link", link);
            if (image) formData.append("image", image);
            if (video) formData.append("video", video);

            onMute(formData); // Pass formData to the onMute function
        }
    };

    const modalStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 1000,
    };

    const modalContentStyles = {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "700px",
        maxHeight: "80vh",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        position: "relative",
    };

    const scrollContentStyles = {
        maxHeight: "40vh",
        overflowY: "auto",
        padding: "10px",
    };

    const closeButtonStyles = {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "#6c757d",
        color: "#fff",
        padding: "8px 12px",
        borderRadius: "5px",
        cursor: "pointer",
        border: "none",
    };

    const inputStyles = {
        width: "100%",
        padding: "10px",
        fontSize: "16px",
        borderRadius: "5px",
        border: "1px solid #ddd",
    };

    const buttonStyles = {
        backgroundColor: "#007BFF",
        color: "#fff",
        padding: "8px 16px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "14px",
        margin: "5px 0",
    };

    const textareaStyles = {
        width: "100%",
        padding: "12px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        resize: "none",
        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.1)",
        marginBottom: "20px",
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <button style={closeButtonStyles} onClick={() => {
                    closeinternalModel()
                }}>
                    Close
                </button>
                <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Mute Video Comment</h1>
                <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                    <input
                        type="text"
                        placeholder="Search by username"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                        style={inputStyles}
                    />
                    <button style={buttonStyles} onClick={handleSearch}>
                        Search
                    </button>
                </div>

                {searchresult?.id && (
                    <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
                        <thead>
                            <tr>
                                <th style={{ padding: "10px", border: "1px solid #ddd" }}>ID</th>
                                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Username</th>
                                <th style={{ padding: "10px", border: "1px solid #ddd" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={searchresult.id}>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{searchresult.id}</td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>{searchresult.username}</td>
                                <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                    <button style={buttonStyles} onClick={() => handleSelect(searchresult)}>
                                        Select
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                )}

                {openModel && (
                    <div style={scrollContentStyles}>
                        <CustomTimePicker label="Days" value={days} onChange={setDays} options={dayOptions} />
                        <CustomTimePicker label="Hours" value={hours} onChange={setHours} options={hourOptions} />
                        <CustomTimePicker label="Minutes" value={minutes} onChange={setMinutes} options={minuteOptions} />
                        <CustomTimePicker label="Seconds" value={seconds} onChange={setSeconds} options={secondOptions} />

                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Reason for muting"
                            rows="4"
                            style={textareaStyles}
                        />

                        <input
                            type="text"
                            placeholder="Enter a link"
                            value={link}
                            onChange={(e) => setLink(e.target.value)}
                            style={{ ...inputStyles, marginBottom: "10px" }}
                        />
                        {/* Image Upload */}
                        <div style={{ marginBottom: "10px" }}>
                            <label style={{ display: "block", marginBottom: "5px" }}>
                                Image:
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => setImage(e.target.files[0])}
                                style={{ fontSize: "14px" }}
                            />
                        </div>
                        {/* Video Upload */}
                        <div style={{ marginBottom: "10px" }}>
                            <label style={{ display: "block", marginBottom: "5px" }}>
                                Video:
                            </label>
                            <input
                                type="file"
                                accept="video/*"
                                onChange={(e) => setVideo(e.target.files[0])}
                                style={{ fontSize: "14px" }}
                            />
                        </div>

                        <div style={{ textAlign: "center" }}>
                            <button style={buttonStyles} onClick={() => handleMute()}>Confirm Mute</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// **********************************edit section*************************
// const EditVideoSectionModel = ({ CloseModel}) => {


//   const modalStyles = {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.7)",
//     zIndex: 1000,
//   };

//   const modalContentStyles = {
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     width: "90%",
//     maxWidth: "700px",
//     maxHeight: "80vh",
//     overflow: "hidden",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//     position: "relative",
//   };


//   const closeButtonStyles = {
//     position: "absolute",
//     top: "10px",
//     right: "10px",
//     backgroundColor: "#6c757d",
//     color: "#fff",
//     padding: "8px 12px",
//     borderRadius: "5px",
//     cursor: "pointer",
//     border: "none",
//   };



//   return (
//     <div style={modalStyles}>
//       <div style={modalContentStyles}>
//         <button style={closeButtonStyles} onClick={() => {
//           // closeinternalModel()
//         }}>
//           Close
//         </button>
//         <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Edit Video Info</h1>
//              </div>
//     </div>
//   );
// };

const EditVideoSectionModel = ({ CloseModel, selectedvideoinfo, HandleEditVideoInfo }) => {
    const [activeTab, setActiveTab] = useState("title"); // "title" or "description"
    const [title, setTitle] = useState(selectedvideoinfo?.title); // Video title
    const [description, setDescription] = useState(selectedvideoinfo?.description); // Video description
    console.log(selectedvideoinfo?.user?.account_type, 'selectedvideoinfoselectedvideoinfo')
    const modalStyles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 1000,
    };

    const modalContentStyles = {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "10px",
        width: "90%",
        maxWidth: "700px",
        maxHeight: "80vh",
        overflowY: "auto",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        position: "relative",
    };

    const closeButtonStyles = {
        position: "absolute",
        top: "10px",
        right: "10px",
        backgroundColor: "#6c757d",
        color: "#fff",
        padding: "8px 12px",
        borderRadius: "5px",
        cursor: "pointer",
        border: "none",
    };

    const tabButtonStyles = (isActive) => ({
        padding: "10px 20px",
        margin: "0 5px",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
        fontWeight: isActive ? "bold" : "normal",
        backgroundColor: isActive ? "red" : "#007bff",
        color: isActive ? "#fff" : "#000",
    });

    const textAreaStyles = {
        width: "100%",
        padding: "10px",
        marginBottom: "20px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        resize: "vertical",
    };

    const saveButtonStyles = {
        padding: "10px 20px",
        backgroundColor: "#28a745",
        color: "#fff",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
        marginRight: "10px",
    };

    const cancelButtonStyles = {
        padding: "10px 20px",
        backgroundColor: "gray",
        color: "#fff",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
    };

    const handleSave = () => {
        if (activeTab === "title" && title.length > 15) {
            alert("Error: Title cannot be more than 15 characters!");
            return;
        }
        if (
            activeTab === "description" &&
            ((selectedvideoinfo?.user?.account_type === "basic" && description.length > 500) ||
                (selectedvideoinfo?.user?.account_type !== "basic" && description.length > 1000))
        ) {
            alert(
                `Error: Description cannot exceed ${selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"
                } characters!`
            );
            return;
        }
        const updatedData = {
            type: activeTab,
            value: activeTab === "title" ? title : description,
            VideoId: selectedvideoinfo?.id
        };
        HandleEditVideoInfo(updatedData)
        console.log("Data to save:", updatedData);
        // Call API to save the data
    };

    const handleClean = () => {
        if (activeTab === "title") {
            setTitle(""); // Clear title
        } else if (activeTab === "description") {
            setDescription(""); // Clear description
        }
    };

    return (
        <div style={modalStyles}>
            <div style={modalContentStyles}>
                <button style={closeButtonStyles} onClick={CloseModel}>
                    Close
                </button>

                <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
                    Edit Video Info
                </h1>

                <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                    <button
                        style={tabButtonStyles(activeTab === "title")}
                        onClick={() => setActiveTab("title")}
                    >
                        Edit Title
                    </button>
                    <button
                        style={tabButtonStyles(activeTab === "description")}
                        onClick={() => setActiveTab("description")}
                    >
                        Edit Description
                    </button>
                </div>

                {activeTab === "title" && (
                    <div>
                        <h3>Edit Title</h3>
                        <textarea
                            value={title}
                            onChange={(e) => setTitle(e.target.value)} // Allow input without restrictions
                            rows={4}
                            style={{
                                ...textAreaStyles,
                                border: title.length > 15 ? "2px solid red" : "1px solid #ccc",
                            }}
                            placeholder="Enter video title here..."
                        />
                        {title.length > 15 && (
                            <p style={{ color: "red", fontSize: "12px" }}>
                                Title cannot exceed 15 characters!
                            </p>
                        )}
                        <p style={{ color: "gray", fontSize: "12px" }}>
                            {title.length}/15 characters
                        </p>
                    </div>
                )}


                {activeTab === "description" && (
                    <div>
                        <h3>Edit Description</h3>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={6}
                            style={{
                                ...textAreaStyles,
                                border:
                                    (selectedvideoinfo?.user?.account_type === "basic" && description.length > 500) ||
                                        (selectedvideoinfo?.user?.account_type !== "basic" && description.length > 1000)
                                        ? "4px solid red"
                                        : "1px solid #ccc",
                            }}
                            placeholder="Enter video description here..."
                        />
                        {description.length > (selectedvideoinfo?.user?.account_type === "basic" ? 500 : 1000) && (
                            <p style={{ color: "red", fontSize: "12px" }}>
                                Description cannot exceed{" "}
                                {selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"} characters!
                            </p>
                        )}

                        <p style={{ color: "gray", fontSize: "12px" }}>
                            {description.length}/
                            {selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"} characters
                        </p>
                    </div>
                )}


                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button style={saveButtonStyles} onClick={handleSave}>
                        Save
                    </button>
                    <button style={cancelButtonStyles} onClick={handleClean}>
                        Clean
                    </button>
                </div>
            </div>
        </div>
    );
};

// *************************BlockFeed************************
const BlockVideoModal = ({ isOpen, onClose, blockvideohandler }) => {
    const [reason, setReason] = useState('');
    const [link, setLink] = useState('');
    const [image, setImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    // const [muteAudio, setMuteAudio] = useState(false);

    const handleSubmit = async () => {
        if (reason.length > 100) {
            setErrorMessage("You can only enter up to 100 characters.");
            return;
        }

        // Ensure either a link or an image is provided
        if (!link && !image) {
            setErrorMessage("You must provide either a link or an image.");
            return;
        }

        const formData = new FormData();
        formData.append('reason', reason);
        formData.append('link', link);

        if (image) {
            console.log('hello image');
            formData.append('image', image);
        }

        // Add mute audio data to form if checked
        // formData.append('muteAudio', muteAudio);

        try {
            await blockvideohandler(formData);
            setReason('');
            setLink('');
            setImage(null);
            // setMuteAudio(false); // Reset mute audio checkbox
        } catch (error) {
            setErrorMessage("An error occurred while blocking the feed. Please try again.");
        }
    };

    const Styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
        },
        container: {
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            maxWidth: "500px",
            width: "100%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            position: "relative",
        },
        closeButton: {
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "#6c757d",
            color: "#fff",
            padding: "8px 12px",
            borderRadius: "5px",
            cursor: "pointer",
            border: "none",
            fontSize: "16px",
        },
        title: {
            marginBottom: "20px",
            fontSize: "1.5rem",
            color: "#333",
            textAlign: "center",
        },
        formGroup: {
            marginBottom: "15px",

        },
        formGroupcheckbox: {
            marginBottom: "15px",
            display: "flex",
            alignItems: "center", // Ensures the checkbox and label align properly

        },
        label: {
            fontSize: "1rem",
            color: "#333",
            marginBottom: "5px",
            display: "block",
        },
        input: {
            width: "100%",
            padding: "8px",
            fontSize: "1rem",
            border: "1px solid #ddd",
            borderRadius: "4px",
        },
        textarea: {
            width: "100%",
            padding: "8px",
            fontSize: "1rem",
            border: "1px solid #ddd",
            borderRadius: "4px",
            resize: "vertical",
        },
        errorMessage: {
            color: "red",
            fontSize: "0.875rem",
            marginTop: "10px",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
        },
        cancelButton: {
            padding: "10px 15px",
            fontSize: "1rem",
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        submitButton: {
            padding: "10px 15px",
            fontSize: "1rem",
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        cancelButtonHover: {
            backgroundColor: "#d32f2f",
        },
        submitButtonHover: {
            backgroundColor: "#388e3c",
        },
    };

    return isOpen ? (
        <div style={Styles.overlay}>
            <div style={Styles.container}>
                <h2 style={Styles.title}>Block Video</h2>
                <form onSubmit={e => e.preventDefault()}>
                    <div style={Styles.formGroup}>
                        <label htmlFor="reason" style={Styles.label}>Reason for Blocking:</label>
                        <textarea
                            id="reason"
                            value={reason}
                            onChange={e => {
                                if (e.target.value.length <= 100) {
                                    setReason(e.target.value);
                                    setErrorMessage('');
                                }
                            }}
                            placeholder="Enter the reason here..."
                            rows="4"
                            style={Styles.textarea}
                            maxLength="200"
                            required
                        />
                        {reason.length >= 100 && (
                            <p style={Styles.errorMessage}>You can only enter up to 100 characters.</p>
                        )}
                    </div>
                    <div style={Styles.formGroup}>
                        <label htmlFor="link" style={Styles.label}>Link:</label>
                        <input
                            type="url"
                            id="link"
                            value={link}
                            onChange={e => setLink(e.target.value)}
                            placeholder="Enter the link"
                            style={Styles.input}
                        />
                    </div>
                    <div style={Styles.formGroup}>
                        <label htmlFor="image" style={Styles.label}>Upload Image:</label>
                        <input
                            type="file"
                            id="image"
                            onChange={e => setImage(e.target.files[0])}
                            accept="image/*"
                            style={Styles.input}
                        />
                    </div>
                    {/* <div style={Styles.formGroupcheckbox}>
            <label htmlFor="muteAudio" style={Styles.label}>Mute Audio:</label>
            <input
              type="checkbox"
              id="muteAudio"
              checked={muteAudio}
              onChange={() => setMuteAudio(prevState => !prevState)}
              style={{ ...Styles.input, width: 'auto', marginLeft: '10px' }} // Adjust width and add margin for spacing
            />
          </div> */}

                    {errorMessage && <p style={Styles.errorMessage}>{errorMessage}</p>}
                    <div style={Styles.buttonContainer}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={Styles.cancelButton}
                            onMouseEnter={e => (e.target.style.backgroundColor = Styles.cancelButtonHover.backgroundColor)}
                            onMouseLeave={e => (e.target.style.backgroundColor = Styles.cancelButton.backgroundColor)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            style={Styles.submitButton}
                            onMouseEnter={e => (e.target.style.backgroundColor = Styles.submitButtonHover.backgroundColor)}
                            onMouseLeave={e => (e.target.style.backgroundColor = Styles.submitButton.backgroundColor)}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    ) : null;
};

// ********************************MuteVideoAudioModal******************************

const MuteVideoAudioModal = ({ isOpen, onClose, HandleMuteVideoAudio }) => {
    const [reason, setReason] = useState('');
    const [link, setLink] = useState('');
    const [image, setImage] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = async () => {
        if (reason.length > 100) {
            setErrorMessage("You can only enter up to 100 characters.");
            return;
        }

        // Ensure either a link or an image is provided
        if (!link && !image) {
            setErrorMessage("You must provide either a link or an image.");
            return;
        }

        const formData = new FormData();
        formData.append('reason', reason);
        formData.append('link', link);

        if (image) {
            console.log('hello image');
            formData.append('image', image);
        }


        try {
            await HandleMuteVideoAudio(formData);
            setReason('');
            setLink('');
            setImage(null);
        } catch (error) {
            setErrorMessage("An error occurred while Mute Videoo Audio . Please try again.");
        }
    };

    const Styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
        },
        container: {
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            maxWidth: "500px",
            width: "100%",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            position: "relative",
        },
        closeButton: {
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "#6c757d",
            color: "#fff",
            padding: "8px 12px",
            borderRadius: "5px",
            cursor: "pointer",
            border: "none",
            fontSize: "16px",
        },
        title: {
            marginBottom: "20px",
            fontSize: "1.5rem",
            color: "#333",
            textAlign: "center",
        },
        formGroup: {
            marginBottom: "15px",

        },
        formGroupcheckbox: {
            marginBottom: "15px",
            display: "flex",
            alignItems: "center", // Ensures the checkbox and label align properly

        },
        label: {
            fontSize: "1rem",
            color: "#333",
            marginBottom: "5px",
            display: "block",
        },
        input: {
            width: "100%",
            padding: "8px",
            fontSize: "1rem",
            border: "1px solid #ddd",
            borderRadius: "4px",
        },
        textarea: {
            width: "100%",
            padding: "8px",
            fontSize: "1rem",
            border: "1px solid #ddd",
            borderRadius: "4px",
            resize: "vertical",
        },
        errorMessage: {
            color: "red",
            fontSize: "0.875rem",
            marginTop: "10px",
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
        },
        cancelButton: {
            padding: "10px 15px",
            fontSize: "1rem",
            backgroundColor: "#f44336",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        submitButton: {
            padding: "10px 15px",
            fontSize: "1rem",
            backgroundColor: "#4caf50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        cancelButtonHover: {
            backgroundColor: "#d32f2f",
        },
        submitButtonHover: {
            backgroundColor: "#388e3c",
        },
    };

    return isOpen ? (
        <div style={Styles.overlay}>
            <div style={Styles.container}>
                <h2 style={Styles.title}>Mute Video Audio</h2>
                <form onSubmit={e => e.preventDefault()}>
                    <div style={Styles.formGroup}>
                        <label htmlFor="reason" style={Styles.label}>Reason for Muting:</label>
                        <textarea
                            id="reason"
                            value={reason}
                            onChange={e => {
                                if (e.target.value.length <= 100) {
                                    setReason(e.target.value);
                                    setErrorMessage('');
                                }
                            }}
                            placeholder="Enter the reason here..."
                            rows="4"
                            style={Styles.textarea}
                            maxLength="200"
                            required
                        />
                        {reason.length >= 100 && (
                            <p style={Styles.errorMessage}>You can only enter up to 100 characters.</p>
                        )}
                    </div>
                    <div style={Styles.formGroup}>
                        <label htmlFor="link" style={Styles.label}>Link:</label>
                        <input
                            type="url"
                            id="link"
                            value={link}
                            onChange={e => setLink(e.target.value)}
                            placeholder="Enter the link"
                            style={Styles.input}
                        />
                    </div>
                    <div style={Styles.formGroup}>
                        <label htmlFor="image" style={Styles.label}>Upload Image:</label>
                        <input
                            type="file"
                            id="image"
                            onChange={e => setImage(e.target.files[0])}
                            accept="image/*"
                            style={Styles.input}
                        />
                    </div>


                    {errorMessage && <p style={Styles.errorMessage}>{errorMessage}</p>}
                    <div style={Styles.buttonContainer}>
                        <button
                            type="button"
                            onClick={onClose}
                            style={Styles.cancelButton}
                            onMouseEnter={e => (e.target.style.backgroundColor = Styles.cancelButtonHover.backgroundColor)}
                            onMouseLeave={e => (e.target.style.backgroundColor = Styles.cancelButton.backgroundColor)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSubmit}
                            style={Styles.submitButton}
                            onMouseEnter={e => (e.target.style.backgroundColor = Styles.submitButtonHover.backgroundColor)}
                            onMouseLeave={e => (e.target.style.backgroundColor = Styles.submitButton.backgroundColor)}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    ) : null;
};
